<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Kasir" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid no-print">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <!-- <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
                <div class="col-md-7 pr-1" v-if="detailLeftTop">
                    <DetailLeft :detailLeftTop="detailLeftTop"/>
                </div>
                <div class="col-md-5 pl-1" v-if="detailRightTop">
                    <DetailRight :detailRightTop="detailRightTop"/>
                </div>
            </div> -->
          <b-row class="mt-2">
            <b-col md="8">
              <a
                class="btn btn-info btn-with-icon-right btn-block"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="accordion-1"
                @click="visible = !visible"
                >{{ visible ? "Sembunyikan" : "Lihat" }} Rincian Pembayaran
                <i class="material-symbols-outlined">{{
                  visible ? "expand_less" : "expand_more"
                }}</i>
              </a>
            </b-col>
            <b-col md="4">
              <b-button
                block
                variant="primary btn-with-icon-left"
                @click="print"
              >
                <i class="material-symbols-outlined">print</i>
                Cetak
                {{
                  ringkasan &&
                  ringkasan.all_tagihan_count &&
                  ringkasan.all_tagihan_count.status == "LUNAS"
                    ? "Invoice"
                    : "Nota Pembayaran"
                }}
              </b-button>
            </b-col>
          </b-row>

          <b-collapse
            id="accordion-1"
            v-model="visible"
            accordion="my-accordion"
            role="tabpanel"
          >
            <div
              id="tagihanRalan"
              class="mt-4 mb-2"
              v-if="
                (doc && doc.length) ||
                  (nrs && nrs.length) ||
                  (both && both.length)
              "
            >
              <div class="row">
                <div class="col-md-10">
                  <h4 class="mb-0">Tagihan Rawat Jalan</h4>
                </div>
                <div class="col-md-2">
                  <button
                    type="button"
                    class="
                      btn
                      btn-outline-secondary
                      btn-sm
                      btn-with-icon-left
                      btn-block
                    "
                    @click="$bvModal.show('ModalFormTindakan')"
                    v-if="
                      ringkasan &&
                        ringkasan.all_tagihan_count &&
                        ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                    "
                  >
                    <i class="material-symbols-outlined">create</i> Edit Tagihan
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12" style="position: relative">
                  <div
                    class="d-flex flex-between mt-4 mb-3"
                    v-if="doc && doc.length"
                  >
                    <h5 class="mb-2">Penanganan oleh Dokter</h5>
                  </div>
                  <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'doc')" v-if="s_doc && a_doc" :loading="l_doc" :data="r_doc" /> -->

                  <table v-if="doc && doc.length" class="responsive">
                    <thead>
                      <th>KODE</th>
                      <th>NAMA PERAWATAN</th>
                      <th>KATEGORI PERAWATAN</th>
                      <th v-if="id_asuransi != 1">DT</th>
                      <th>TARIF/BIAYA</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in doc"
                        v-bind:key="item.id + Math.random(1024)"
                      >
                        <td>{{ item.tindakan.kode }}</td>
                        <td>{{ item.tindakan.nama }}</td>
                        <td>{{ item.tindakan.kategori }}</td>
                        <td v-if="id_asuransi != 1">
                          {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                        </td>
                        <td>{{ item.tindakan.formatted_biaya }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                        <td>
                          <h4 class="my-2">Total Biaya Penanganan Dokter</h4>
                        </td>
                        <td colspan="1" class="text-right">
                          <h4 class="my-2">{{ convertToRupiah(doc_count) }}</h4>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <div
                    class="d-flex flex-between mt-4 mb-3"
                    v-if="nrs && nrs.length"
                  >
                    <h5 class="mb-2">Penanganan oleh Petugas</h5>
                  </div>
                  <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'nrs')" v-if="s_nrs && a_nrs" :loading="l_nrs" :data="r_nrs" /> -->
                  <table class="responsive" v-if="nrs && nrs.length">
                    <thead>
                      <th>KODE</th>
                      <th>NAMA PERAWATAN</th>
                      <th>KATEGORI PERAWATAN</th>
                      <th v-if="id_asuransi != 1">DT</th>
                      <th>TARIF/BIAYA</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in nrs"
                        v-bind:key="item.id + Math.random(1024)"
                      >
                        <td>{{ item.tindakan.kode }}</td>
                        <td>{{ item.tindakan.nama }}</td>
                        <td>{{ item.tindakan.kategori }}</td>
                        <td v-if="id_asuransi != 1">
                          {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                        </td>
                        <td>{{ item.tindakan.formatted_biaya }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                        <td>
                          <h4 class="my-2">Total Biaya Penanganan Petugas</h4>
                        </td>
                        <td colspan="1" class="text-right">
                          <h4 class="my-2">{{ convertToRupiah(nrs_count) }}</h4>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <div
                    class="d-flex flex-between mt-4 mb-3"
                    v-if="both && both.length"
                  >
                    <h5 class="mb-2">Penanganan oleh Dokter dan Petugas</h5>
                  </div>
                  <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'both')" v-if="s_both && a_both" :loading="l_both" :data="r_both" /> -->
                  <table class="responsive" v-if="both && both.length">
                    <thead>
                      <th>KODE</th>
                      <th>NAMA PERAWATAN</th>
                      <th>KATEGORI PERAWATAN</th>
                      <th v-if="id_asuransi != 1">DT</th>
                      <th>TARIF/BIAYA</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in both"
                        v-bind:key="item.id + Math.random(1024)"
                      >
                        <td>{{ item.tindakan.kode }}</td>
                        <td>{{ item.tindakan.nama }}</td>
                        <td>{{ item.tindakan.kategori }}</td>
                        <td v-if="id_asuransi != 1">
                          {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                        </td>
                        <td>{{ item.tindakan.formatted_biaya }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                        <td>
                          <h4 class="my-2">
                            Total Biaya Penanganan Dokter dan Petugas
                          </h4>
                        </td>
                        <td colspan="1" class="text-right">
                          <h4 class="my-2">
                            {{ convertToRupiah(both_count) }}
                          </h4>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <hr />
                </div>
              </div>
            </div>
            <div id="tagihanRanap" class="mt-4 mb-2" v-if="ranapRingkasan">
              <h4 class="mb-0">Tagihan Rawat Inap</h4>

              <div class="row">
                <div class="col-md-12">
                  <div
                    class="row my-3"
                    v-if="dataTagihanKamarRanap && dataTagihanKamarRanap.length"
                  >
                    <div class="col-md-10">
                      <h5 class="mb-0">Tagihan Kamar Inap</h5>
                    </div>
                    <div class="col-md-2">
                      <!-- <button
                        type="button"
                        class="
                          btn
                          btn-sm
                          btn-outline-secondary
                          btn-with-icon-left
                          btn-block
                        "
                        @click="$bvModal.show('ModalFormKamarRanap')"
                      >
                        <i class="material-symbols-outlined">create</i> Edit Tagihan
                      </button> -->
                    </div>
                  </div>
                  <table
                    class="responsive"
                    v-if="dataTagihanKamarRanap && dataTagihanKamarRanap.length"
                  >
                    <thead>
                      <th>TANGGAL</th>
                      <th>NAMA KAMAR</th>
                      <th>NO. KASUR</th>
                      <th>KELAS</th>
                      <th>TARIF/BIAYA</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in dataTagihanKamarRanap"
                        v-bind:key="item.id"
                      >
                        <td>{{ item.formatted_tgl }}</td>
                        <td>{{ `${item.kamar_ranap.nama}` }}</td>
                        <td>{{ item.kamar_ranap.formatted_no_kasur }}</td>
                        <td>{{ `${item.kamar_ranap.formatted_kelas}` }}</td>
                        <td>
                          {{ item.formatted_biaya }}
                          <!-- <router-link
                            class="btn btn-icon btn-primary btn-sm mr-2 ml-3"
                            :to="`/ranap/form-tagihan/${$route.params.id}/edit/${item.id}`"
                          >
                            <i class="material-symbols-outlined">create</i>
                          </router-link> -->
                          <!-- <button class="btn btn-icon btn-danger btn-sm">
                            <i class="material-symbols-outlined">delete</i>
                          </button> -->
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <!-- <td :colspan="id_asuransi != 1 ? 4 : 3"></td> -->
                        <td :colspan="3"></td>
                        <td>
                          <h4 class="my-2">Total Tagihan</h4>
                        </td>
                        <td>
                          <h4 class="my-2 text-right">
                            {{ convertToRupiah(totalTagihanTagihanKamarRanap) }}
                          </h4>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div
                class="row mt-4 mb-0"
                v-if="
                  (ranapDoc && ranapDoc.length) ||
                    (ranapNrs && ranapNrs.length) ||
                    (ranapBoth && ranapBoth.length)
                "
              >
                <div class="col-md-10">
                  <h5 class="mb-0">Tagihan Tindakan Rawat Inap</h5>
                </div>
                <div class="col-md-2">
                  <button
                    type="button"
                    class="
                      btn
                      btn-outline-secondary
                      btn-sm
                      btn-with-icon-left
                      btn-block
                    "
                    v-if="
                      ringkasan &&
                        ringkasan.all_tagihan_count &&
                        ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                    "
                    @click="$bvModal.show('ModalFormTindakan Ranap')"
                  >
                    <i class="material-symbols-outlined">create</i> Edit Tagihan
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12" style="position: relative">
                  <div
                    class="d-flex flex-between mt-4 mb-3"
                    v-if="ranapDoc && ranapDoc.length"
                  >
                    <h5 class="mb-2">Penanganan oleh Dokter</h5>
                  </div>
                  <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'ranapDoc')" v-if="s_ranapDoc && a_ranapDoc" :loading="l_ranapDoc" :data="r_ranapDoc" /> -->

                  <table v-if="ranapDoc && ranapDoc.length" class="responsive">
                    <thead>
                      <th>KODE</th>
                      <th>NAMA PERAWATAN</th>
                      <th>KATEGORI PERAWATAN</th>
                      <th v-if="id_asuransi != 1">DT</th>
                      <th>TARIF/BIAYA</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in ranapDoc"
                        v-bind:key="item.id + Math.random(1024)"
                      >
                        <td>{{ item.tindakan.kode }}</td>
                        <td>{{ item.tindakan.nama }}</td>
                        <td>{{ item.tindakan.kategori }}</td>
                        <td v-if="id_asuransi != 1">
                          {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                        </td>
                        <td>{{ item.tindakan.formatted_biaya }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                        <td>
                          <h4 class="my-2">Total Biaya Penanganan Dokter</h4>
                        </td>
                        <td colspan="1" class="text-right">
                          <h4 class="my-2">
                            {{ convertToRupiah(ranapDoc_count) }}
                          </h4>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <div
                    class="d-flex flex-between mt-4 mb-3"
                    v-if="ranapNrs && ranapNrs.length"
                  >
                    <h5 class="mb-2">Penanganan oleh Petugas</h5>
                  </div>
                  <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'ranapNrs')" v-if="s_ranapNrs && a_ranapNrs" :loading="l_ranapNrs" :data="r_ranapNrs" /> -->
                  <table class="responsive" v-if="ranapNrs && ranapNrs.length">
                    <thead>
                      <th>KODE</th>
                      <th>NAMA PERAWATAN</th>
                      <th>KATEGORI PERAWATAN</th>
                      <th v-if="id_asuransi != 1">DT</th>
                      <th>TARIF/BIAYA</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in ranapNrs"
                        v-bind:key="item.id + Math.random(1024)"
                      >
                        <td>{{ item.tindakan.kode }}</td>
                        <td>{{ item.tindakan.nama }}</td>
                        <td>{{ item.tindakan.kategori }}</td>
                        <td v-if="id_asuransi != 1">
                          {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                        </td>
                        <td>{{ item.tindakan.formatted_biaya }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                        <td>
                          <h4 class="my-2">Total Biaya Penanganan Petugas</h4>
                        </td>
                        <td colspan="1" class="text-right">
                          <h4 class="my-2">
                            {{ convertToRupiah(ranapNrs_count) }}
                          </h4>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <div
                    class="d-flex flex-between mt-4 mb-3"
                    v-if="ranapBoth && ranapBoth.length"
                  >
                    <h5 class="mb-2">Penanganan oleh Dokter dan Petugas</h5>
                  </div>
                  <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'ranapBoth')" v-if="s_ranapBoth && a_ranapBoth" :loading="l_ranapBoth" :data="r_ranapBoth" /> -->
                  <table
                    class="responsive"
                    v-if="ranapBoth && ranapBoth.length"
                  >
                    <thead>
                      <th>KODE</th>
                      <th>NAMA PERAWATAN</th>
                      <th>KATEGORI PERAWATAN</th>
                      <th v-if="id_asuransi != 1">DT</th>
                      <th>TARIF/BIAYA</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in ranapBoth"
                        v-bind:key="item.id + Math.random(1024)"
                      >
                        <td>{{ item.tindakan.kode }}</td>
                        <td>{{ item.tindakan.nama }}</td>
                        <td>{{ item.tindakan.kategori }}</td>
                        <td v-if="id_asuransi != 1">
                          {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                        </td>
                        <td>{{ item.tindakan.formatted_biaya }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                        <td>
                          <h4 class="my-2">
                            Total Biaya Penanganan Dokter dan Petugas
                          </h4>
                        </td>
                        <td colspan="1" class="text-right">
                          <h4 class="my-2">
                            {{ convertToRupiah(ranapBoth_count) }}
                          </h4>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <hr />
                </div>
              </div>
            </div>
            <div id="tagihanObat" class="mt-4 mb-2" v-if="obatRingkasan">
              <div class="row">
                <div class="col-md-10">
                  <h4 class="mb-0">Tagihan Obat / Alkes</h4>
                </div>
                <div class="col-md-2">
                  <button
                    type="button"
                    class="
                      btn
                      btn-outline-secondary
                      btn-sm
                      btn-with-icon-left
                      btn-block
                    "
                    v-if="
                      ringkasan &&
                        ringkasan.all_tagihan_count &&
                        ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                    "
                    @click="$bvModal.show('ModalFormObat')"
                  >
                    <i class="material-symbols-outlined">create</i> Edit Tagihan
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12" style="position: relative">
                  <div class="d-flex flex-between my-3" v-if="obat.length">
                    <h5 class="mb-2">Resep Obat / Alkes</h5>
                  </div>
                  <table class="responsive" v-if="obat.length">
                    <thead>
                      <th>KODE / NAMA BARANG / JENIS OBAT / GOLONGAN OBAT</th>
                      <!-- <th>LOKASI</th> -->
                      <th>HARGA/SATUAN</th>
                      <th>JUMLAH</th>
                      <th>EMBALASE</th>
                      <th>TUSLAH</th>
                      <th>DISKON</th>
                      <th>ATURAN PAKAI</th>
                      <th v-if="id_asuransi != 1">DT</th>
                      <th>SUB TOTAL</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in obat"
                        v-bind:key="item.id + Math.random(1024)"
                      >
                        <td>
                          {{ item.kode }} / {{ item.nama }} / {{ item.jenis }} /
                          {{ item.golongan_obat }}
                        </td>
                        <td>{{ item.formatted_harga }}</td>
                        <td>{{ item.jumlah }}</td>
                        <td>{{ item.formatted_embalase }}</td>
                        <td>{{ item.formatted_tuslah }}</td>
                        <td>
                          {{ item.diskon_type != "Percentage" ? "Rp  " : ""
                          }}{{ convertToMoney(item.diskon)
                          }}{{ item.diskon_type == "Percentage" ? "%" : "" }}
                        </td>
                        <td>{{ item.catatan_dokter }}</td>
                        <td v-if="id_asuransi != 1">
                          {{ item.obat.ditanggung == 1 ? "Ya" : "Tdk" }}
                        </td>
                        <td>{{ item.formatted_sub_total }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td :colspan="id_asuransi != 1 ? 2 : 1"></td>
                        <td colspan="6">
                          <h4 class="my-2">Total Biaya Obat / Alkes</h4>
                        </td>
                        <td colspan="1" class="text-right">
                          <h4 class="my-2">
                            {{ convertToRupiah(obat_count) }}
                          </h4>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <hr />
                </div>
              </div>
            </div>
            <div id="tagihanOptik" class="mt-4 mb-2" v-if="optikRingkasan">
              <div class="row">
                <div class="col-md-10">
                  <h4 class="mb-0">Tagihan Optik</h4>
                </div>
                <div class="col-md-2">
                  <button
                    type="button"
                    class="
                      btn
                      btn-outline-secondary
                      btn-sm
                      btn-with-icon-left
                      btn-block
                    "
                    v-if="
                      ringkasan &&
                        ringkasan.all_tagihan_count &&
                        ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                    "
                    @click="$bvModal.show('ModalFormOptik')"
                  >
                    <i class="material-symbols-outlined">create</i> Edit Tagihan
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12" style="position: relative">
                  <div class="d-flex flex-between my-3" v-if="optik.length">
                    <h5 class="mb-2">Resep Optik</h5>
                  </div>
                  <table class="responsive" v-if="optik.length">
                    <thead>
                      <th>KODE</th>
                      <th>NAMA BARANG</th>
                      <th>JENIS OBAT</th>
                      <th>LOKASI</th>
                      <th>HARGA/SATUAN</th>
                      <th>JUMLAH</th>
                      <th>EMBALASE</th>
                      <th>TUSLAH</th>
                      <th v-if="id_asuransi != 1">DT</th>
                      <th>SUB TOTAL</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in optik"
                        v-bind:key="item.id + Math.random(1024)"
                      >
                        <td>{{ item.optik.kode }}</td>
                        <td>{{ item.optik.nama }}</td>
                        <td>{{ item.optik.jenis }}</td>
                        <td>{{ item.optik.lokasi }}</td>
                        <td>{{ item.formatted_harga }}</td>
                        <td>{{ item.jumlah }}</td>
                        <td>{{ item.formatted_embalase }}</td>
                        <td>{{ item.formatted_tuslah }}</td>
                        <td v-if="id_asuransi != 1">
                          {{ item.optik.ditanggung == 1 ? "Ya" : "Tdk" }}
                        </td>
                        <td>{{ item.formatted_sub_total }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td :colspan="id_asuransi != 1 ? 4 : 3"></td>
                        <td colspan="5">
                          <h4 class="my-2">Total Biaya Optik</h4>
                        </td>
                        <td colspan="1" class="text-right">
                          <h4 class="my-2">
                            {{ convertToRupiah(optik_count) }}
                          </h4>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <hr />
                </div>
              </div>
            </div>
            <div
              id="tagihanRalanLab"
              class="mt-4 mb-2"
              v-if="ralanLabRingkasan"
            >
              <div class="row mb-3">
                <div class="col-md-10">
                  <h4 class="mb-0">Tagihan Lab Rawat Jalan</h4>
                </div>
                <div class="col-md-2">
                  <button
                    type="button"
                    class="
                      btn
                      btn-outline-secondary
                      btn-sm
                      btn-with-icon-left
                      btn-block
                    "
                    v-if="
                      ringkasan &&
                        ringkasan.all_tagihan_count &&
                        ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                    "
                    @click="$bvModal.show('ModalFormLab')"
                  >
                    <i class="material-symbols-outlined">create</i> Edit Tagihan
                  </button>
                </div>
              </div>
              <table class="responsive" v-if="ralanLab.length">
                <thead>
                  <th>KODE</th>
                  <th>NAMA PEMERIKSAAN LAB</th>
                  <th v-if="id_asuransi != 1">DT</th>
                  <th>TARIF/BIAYA</th>
                </thead>
                <tbody>
                  <tr
                    v-for="item in ralanLab"
                    v-bind:key="item.id + Math.random(1024)"
                  >
                    <td>{{ item.periksalab.kode }}</td>
                    <td>{{ item.periksalab.nama }}</td>
                    <td v-if="id_asuransi != 1">
                      {{ item.periksalab.ditanggung == 1 ? "Ya" : "Tdk" }}
                    </td>
                    <td>{{ item.formatted_biaya }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td :colspan="id_asuransi != 1 ? 2 : 1"></td>
                    <td>
                      <h4 class="my-2">Total Biaya Pemeriksaan Lab</h4>
                    </td>
                    <td colspan="1" class="text-right">
                      <h4 class="my-2">{{ convertToRupiah(ralanLabCount) }}</h4>
                    </td>
                  </tr>
                </tfoot>
              </table>
              <hr />
            </div>
            <div
              id="tagihanRanapLab"
              class="mt-4 mb-2"
              v-if="ranapLabRingkasan"
            >
              <div class="row mb-3">
                <div class="col-md-10">
                  <h4 class="mb-0">Tagihan Lab Rawat Inap</h4>
                </div>
                <div class="col-md-2">
                  <button
                    type="button"
                    class="
                      btn
                      btn-outline-secondary
                      btn-sm
                      btn-with-icon-left
                      btn-block
                    "
                    @click="$bvModal.show('ModalFormLabRanap')"
                    v-if="
                      ringkasan &&
                        ringkasan.all_tagihan_count &&
                        ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                    "
                  >
                    <i class="material-symbols-outlined">create</i> Edit Tagihan
                  </button>
                </div>
              </div>
              <table class="responsive" v-if="ranapLab.length">
                <thead>
                  <th>KODE</th>
                  <th>NAMA PEMERIKSAAN LAB</th>
                  <th v-if="id_asuransi != 1">DT</th>
                  <th>TARIF/BIAYA</th>
                </thead>
                <tbody>
                  <tr
                    v-for="item in ranapLab"
                    v-bind:key="item.id + Math.random(1024)"
                  >
                    <td>{{ item.periksalab.kode }}</td>
                    <td>{{ item.periksalab.nama }}</td>
                    <td v-if="id_asuransi != 1">
                      {{ item.periksalab.ditanggung == 1 ? "Ya" : "Tdk" }}
                    </td>
                    <td>{{ item.formatted_biaya }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td :colspan="id_asuransi != 1 ? 2 : 1"></td>
                    <td>
                      <h4 class="my-2">Total Biaya Pemeriksaan Lab</h4>
                    </td>
                    <td colspan="1" class="text-right">
                      <h4 class="my-2">{{ convertToRupiah(ranapLabCount) }}</h4>
                    </td>
                  </tr>
                </tfoot>
              </table>
              <hr />
            </div>
            <div id="tagihanOperasi" class="mt-4 mb-2" v-if="operasiRingkasan">
              <div class="row mb-3">
                <div class="col-md-10">
                  <h4 class="mb-0">Tagihan Operasi</h4>
                </div>
                <div class="col-md-2">
                  <button
                    type="button"
                    class="
                      btn
                      btn-outline-secondary
                      btn-sm
                      btn-with-icon-left
                      btn-block
                    "
                    v-if="
                      ringkasan &&
                        ringkasan.all_tagihan_count &&
                        ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                    "
                    @click="$bvModal.show('ModalFormOperasi')"
                  >
                    <i class="material-symbols-outlined">create</i> Edit Tagihan
                  </button>
                </div>
              </div>
              <table class="responsive" v-if="operasi">
                <thead>
                  <th>KOMPONEN BIAYA</th>
                  <th>SUB TOTAL</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Biaya Paket Operasi</td>
                    <td>
                      {{ convertToRupiah(operasi.jenis_paket_operasi) }}
                    </td>
                  </tr>
                  <tr>
                    <td>Jasa Dokter Operator</td>
                    <td>
                      {{ convertToRupiah(operasi.jasa_dokter_operator) }}
                    </td>
                  </tr>
                  <tr>
                    <td>Jasa Dokter Anestesi</td>
                    <td>
                      {{ convertToRupiah(operasi.jasa_dokter_anestesi) }}
                    </td>
                  </tr>
                  <!-- <tr>
                      <td>Jasa Dokter Referal</td>
                      <td>
                        {{ convertToRupiah(operasi.jasa_dokter_referal) }}
                      </td>
                    </tr> -->
                  <tr>
                    <td>Jasa Perawat Anestesi</td>
                    <td>
                      {{ convertToRupiah(operasi.jasa_perawat_anestesi) }}
                    </td>
                  </tr>
                  <tr>
                    <td>Jasa Instrumentator</td>
                    <td>
                      {{ convertToRupiah(operasi.jasa_instrumentator) }}
                    </td>
                  </tr>
                  <tr>
                    <td>Jasa Perawat Sirkuler</td>
                    <td>
                      {{ convertToRupiah(operasi.jasa_perawat_sirkuler) }}
                    </td>
                  </tr>
                  <tr>
                    <td>Sewa Kamar Operasi</td>
                    <td>{{ convertToRupiah(operasi.sewa_kamar_operasi) }}</td>
                  </tr>
                  <tr>
                    <td>Pemberian Obat Dan Alat Kesehatan</td>
                    <td>
                      {{
                        convertToRupiah(
                          operasi.pemberian_obat_dan_alat_kesehatan
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Biaya Lain-lain</td>
                    <td>{{ convertToRupiah(operasi.biaya_lain_lain) }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>
                      <h4 class="my-2">Total Biaya Operasi</h4>
                    </td>
                    <td colspan="1" class="text-right">
                      <h4 class="my-2">
                        {{ convertToRupiah(operasi.total_tagihan) }}
                      </h4>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div class="row my-3">
              <div class="col-md-4 offset-md-2">
                <h4 class="mb-0 text-uppercase">Total Pembayaran</h4>
              </div>
              <div class="col-md-6">
                <h4 class="mb-0 text-right text-secondary">
                  {{
                    ringkasan
                      ? convertToRupiah(ringkasan.all_tagihan_count.total_bayar)
                      : "Rp 0"
                  }}
                </h4>
              </div>
            </div>
          </b-collapse>
          <div class="py-1"></div>
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal melakukan pembayaran',
              content:
                'Terjadi kesalahan saat melakukan pembayaran, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil melakukan pembayaran',
              content: 'Proses pembayaran berhasil dilakukan',
            }"
          />
          <b-tabs pills style="margin-top: 16px; margin-bottom: 8px">
            <b-tab
              title="Bayar"
              :active="tab == 'rincian'"
              @click="tab = 'rincian'"
            >
              <div class="card px-4 py-3 mb-2 mt-3" v-if="ringkasan">
                <div class="row mb-3">
                  <div class="col-md-6">
                    <span
                      :class="
                        `badge badge-${
                          ringkasan &&
                          ringkasan.all_tagihan_count &&
                          ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                            ? 'danger'
                            : ringkasan &&
                              ringkasan.all_tagihan_count &&
                              ringkasan.all_tagihan_count.status ==
                                'BELUM LUNAS'
                            ? 'warning'
                            : 'primary'
                        }`
                      "
                      >{{ ringkasan.all_tagihan_count.status }}</span
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <!-- <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Nomor Pembayaran</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="mb-0">
                          {{
                            ringkasan
                              ? ringkasan.all_tagihan_count.no_pembayaran
                              : ""
                          }}
                        </h4>
                      </div>
                    </div> -->
                    <!-- <hr /> -->
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Total Pembayaran</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="mb-0">
                          {{
                            ringkasan
                              ? convertToRupiah(
                                  ringkasan.all_tagihan_count.total_bayar
                                )
                              : "Rp 0"
                          }}
                        </h4>
                      </div>
                    </div>
                    <div
                      class="row mb-3"
                      v-if="ringkasan.all_tagihan_count.ditanggung"
                    >
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Ditanggung</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="">
                          {{
                            ringkasan
                              ? convertToRupiah(
                                  ringkasan.all_tagihan_count.ditanggung
                                )
                              : "Rp 0"
                          }}
                        </h4>
                        <h5 class="text-secondary">
                          Ditanggung oleh {{ asuransi[id_asuransi] }}
                          {{
                            asuransiLain ? ": " + asuransiLain.data.nama : ""
                          }}
                        </h5>
                        <h5
                          class="text-muted"
                          v-if="
                            ralan &&
                              ralan.data &&
                              ralan.data.pasien &&
                              ralan.data.pasien.no_peserta
                          "
                        >
                          Nomor Peserta : {{ ralan.data.pasien.no_peserta }}
                        </h5>
                        <!-- <div class="card p-2 my-3" style="background:#7f8f9">
                                <p class="mb-1">Ditanggung oleh {{asuransi[id_asuransi]}}</p>
                                <h5 class="mb-0">Ditanggung oleh {{asuransi[id_asuransi]}}</h5>
                            </div> -->
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Yang harus dibayar</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="mb-0 text-info">
                          {{
                            ringkasan
                              ? convertToRupiah(
                                  ringkasan.all_tagihan_count.total_bayar -
                                    ringkasan.all_tagihan_count.ditanggung
                                )
                              : "Rp 0"
                          }}
                        </h4>
                      </div>
                    </div>
                    <hr />
                    <h4
                      class="text-muted"
                      v-if="
                        ringkasan &&
                          ringkasan.all_tagihan_count &&
                          ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                      "
                    >
                      Diskon
                    </h4>
                    <div
                      class="row mb-3 d-flex top"
                      v-if="
                        ringkasan &&
                          ringkasan.all_tagihan_count &&
                          ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                      "
                    >
                      <div class="col-md-9">
                        <FormRow
                          v-for="row in diskonForm"
                          v-bind:key="row.colnum + String(Math.random(1023))"
                          :row="row"
                          :flexStart="true"
                          @handleChange="(e) => handleChangeDiskon(e)"
                        />
                      </div>
                      <div class="col-md-3">
                        <a
                          @click="handleFormDiskon"
                          class="btn btn-secondary btn-block"
                        >
                          Terapkan
                        </a>
                      </div>
                    </div>
                    <div class="row mb-3" v-else>
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Diskon</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="mb-0 text-secondary">
                          {{
                            ringkasan
                              ? convertToRupiah(
                                  ringkasan.all_tagihan_count.diskon
                                )
                              : "Rp 0"
                          }}
                        </h4>
                      </div>
                    </div>
                    <hr />
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Telah dibayar</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="text-primary">
                          {{
                            ringkasan
                              ? convertToRupiah(
                                  ringkasan.all_tagihan_count.dibayar
                                )
                              : "Rp 0"
                          }}
                        </h4>
                        <a
                          class="
                            btn btn-sm btn-outline-secondary btn-with-icon-right
                          "
                          @click="tab = 'riwayat'"
                        >
                          Lihat Riwayat Pembayaran
                          <i class="material-symbols-outlined">chevron_right</i>
                        </a>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Sisa bayar</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="mb-0 text-danger">
                          {{
                            ringkasan
                              ? convertToRupiah(
                                  ringkasan.all_tagihan_count.sisa_tagihan
                                )
                              : "Rp 0"
                          }}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6 no-print"
                    v-if="
                      ringkasan &&
                        !(
                          (ringkasan &&
                            ringkasan.all_tagihan_count &&
                            ringkasan.all_tagihan_count.status == 'LUNAS') ||
                          ringkasan.all_tagihan_count.sisa_tagihan == 0
                        )
                    "
                  >
                    <FormRow
                      v-for="row in bayarForm"
                      v-bind:key="row.colnum + String(Math.random(1023))"
                      :row="row"
                      @handleChange="(e) => handleChange(e)"
                    />
                  </div>
                </div>
                <div
                  class="row"
                  v-if="
                    ringkasan &&
                      !(
                        (ringkasan &&
                          ringkasan.all_tagihan_count &&
                          ringkasan.all_tagihan_count.status == 'LUNAS') ||
                        ringkasan.all_tagihan_count.sisa_tagihan == 0
                      )
                  "
                >
                  <div class="col-md-12">
                    <button
                      @click="handleForm"
                      class="
                        btn btn-primary btn-with-icon-left
                        float-right
                        ml-3
                        text-uppercase
                      "
                    >
                      <i class="material-symbols-outlined">check_circle</i>
                      {{ lunas ? "LUNASI PEMBAYARAN" : "BAYAR" }}
                    </button>
                    <!-- <router-link class="btn btn-outline-danger btn-no-outline float-right text-uppercase" to="/kasir">Batalkan</router-link> -->
                    <a
                      class="
                        btn btn-outline-danger btn-no-outline
                        float-right
                        text-uppercase
                      "
                      @click="() => reset()"
                      >Batalkan</a
                    >
                  </div>
                </div>
              </div>
              <Loading v-else />
            </b-tab>
            <b-tab
              title="Riwayat Pembayaran"
              :active="tab == 'riwayat'"
              @click="tab = 'riwayat'"
            >
              <b-row v-if="riwayat">
                <b-col md="12">
                  <table class="responsive my-4">
                    <thead>
                      <tr>
                        <td colspan="2"></td>
                        <td>
                          <h5 class="my-2">Yang harus dibayar</h5>
                        </td>
                        <td colspan="1" class="text-right">
                          <h5 class="my-2">
                            {{
                              ringkasan
                                ? convertToRupiah(
                                    ringkasan.all_tagihan_count.total_bayar -
                                      ringkasan.all_tagihan_count.ditanggung
                                  )
                                : "Rp 0"
                            }}
                          </h5>
                        </td>
                      </tr>
                      <tr
                        v-if="ringkasan && ringkasan.all_tagihan_count.diskon"
                      >
                        <td colspan="2"></td>
                        <td>
                          <h5 class="my-2">Diskon</h5>
                        </td>
                        <td colspan="1" class="text-right">
                          <h5 class="my-2">
                            {{
                              ringkasan
                                ? convertToRupiah(
                                    ringkasan.all_tagihan_count.diskon
                                  )
                                : "Rp 0"
                            }}
                          </h5>
                        </td>
                      </tr>
                    </thead>
                    <thead v-if="riwayat && riwayat.length">
                      <th>TANGGAL</th>
                      <th>JAM</th>
                      <th>CARA BAYAR</th>
                      <th>JUMLAH PEMBAYARAN</th>
                    </thead>
                    <tbody v-if="riwayat && riwayat.length">
                      <tr
                        v-for="item in riwayat"
                        v-bind:key="item.id + Math.random(1024)"
                      >
                        <td>{{ item.formatted_tanggal }}</td>
                        <td>{{ item.formatted_jam }}</td>
                        <td>
                          {{ item.cara_bayar
                          }}{{ item.no_kartu ? " - " + item.no_kartu : "" }}
                        </td>
                        <td>{{ item.formatted_jumlah }}</td>
                      </tr>
                    </tbody>
                    <tfoot v-if="riwayat && riwayat.length">
                      <tr>
                        <td colspan="2"></td>
                        <td>
                          <h4 class="my-2">SISA PEMBAYARAN</h4>
                        </td>
                        <td colspan="1" class="text-right">
                          <h4 class="mt-2 mb-2">
                            {{
                              ringkasan
                                ? convertToRupiah(
                                    ringkasan.all_tagihan_count.sisa_tagihan
                                  )
                                : "Rp 0"
                            }}
                          </h4>
                          <a
                            class="btn btn-sm btn-secondary btn-with-icon-right"
                            @click="tab = 'rincian'"
                          >
                            {{
                              ringkasan &&
                              ringkasan.all_tagihan_count &&
                              ringkasan.all_tagihan_count.status == "LUNAS"
                                ? "LIHAT RINCIAN"
                                : "LUNASI PEMBAYARAN"
                            }}
                            <i class="material-symbols-outlined"
                              >chevron_right</i
                            >
                          </a>
                        </td>
                      </tr>
                    </tfoot>
                    <tfoot v-else>
                      <tr>
                        <td colspan="2"></td>
                        <td>
                          <p>Belum ada Riwayat Pembayaran di sini</p>
                        </td>
                        <td colspan="1" class="text-right">
                          <a
                            class="btn btn-sm btn-secondary btn-with-icon-right"
                            @click="tab = 'rincian'"
                          >
                            LAKUKAN PEMBAYARAN
                            <i class="material-symbols-outlined"
                              >chevron_right</i
                            >
                          </a>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </b-col>
              </b-row>
              <Loading v-else />
            </b-tab>
          </b-tabs>

          <!--/form-->
        </div>
        <!-- Nota Pembayaran -->
        <div class="container-fluid only-print">
          <div class="row my-4">
            <div class="col-md-10">
              <h3>Nota Pembayaran</h3>
            </div>
            <div class="col-md-2" style="position:relative">
              <div v-if="ringkasan.all_tagihan_count.status != 'LUNAS'">
                <span
                  :class="
                    `badge badge-${
                      ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                        ? 'danger'
                        : ringkasan &&
                          ringkasan.all_tagihan_count &&
                          ringkasan.all_tagihan_count.status == 'BELUM LUNAS'
                        ? 'warning'
                        : 'primary'
                    } block`
                  "
                  >{{ ringkasan.all_tagihan_count.status }}</span
                >
              </div>
              <div v-else>
                <img
                  src="/img/stamp-lunas.png"
                  alt=""
                  srcset=""
                  style="opacity:.5;width:100%;position:absolute;top:-24px;right:0;"
                />
              </div>
            </div>
          </div>

          <DetailTop v-if="detailTop" :detailTop="detailTop" :noPhoto="true" />

          <div
            id="tagihanRalan"
            class="mt-4 mb-2"
            v-if="
              (doc && doc.length) ||
                (nrs && nrs.length) ||
                (both && both.length)
            "
          >
            <div class="row">
              <div class="col-md-10">
                <h4 class="mb-0">Tagihan Rawat Jalan</h4>
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="
                    btn
                    btn-outline-secondary
                    btn-sm
                    btn-with-icon-left
                    btn-block
                  "
                  @click="$bvModal.show('ModalFormTindakan')"
                  v-if="
                    ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                  "
                >
                  <i class="material-symbols-outlined">create</i> Edit Tagihan
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12" style="position: relative">
                <div
                  class="d-flex flex-between mt-4 mb-3"
                  v-if="doc && doc.length"
                >
                  <h5 class="mb-2">Penanganan oleh Dokter</h5>
                </div>
                <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'doc')" v-if="s_doc && a_doc" :loading="l_doc" :data="r_doc" /> -->

                <table v-if="doc && doc.length" class="responsive">
                  <thead>
                    <th>KODE</th>
                    <th>NAMA PERAWATAN</th>
                    <th>KATEGORI PERAWATAN</th>
                    <th v-if="id_asuransi != 1">DT</th>
                    <th>TARIF/BIAYA</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in doc"
                      v-bind:key="item.id + Math.random(1024)"
                    >
                      <td>{{ item.tindakan.kode }}</td>
                      <td>{{ item.tindakan.nama }}</td>
                      <td>{{ item.tindakan.kategori }}</td>
                      <td v-if="id_asuransi != 1">
                        {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                      </td>
                      <td>{{ item.tindakan.formatted_biaya }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                      <td>
                        <h4 class="my-2">Total Biaya Penanganan Dokter</h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2">{{ convertToRupiah(doc_count) }}</h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div
                  class="d-flex flex-between mt-4 mb-3"
                  v-if="nrs && nrs.length"
                >
                  <h5 class="mb-2">Penanganan oleh Petugas</h5>
                </div>
                <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'nrs')" v-if="s_nrs && a_nrs" :loading="l_nrs" :data="r_nrs" /> -->
                <table class="responsive" v-if="nrs && nrs.length">
                  <thead>
                    <th>KODE</th>
                    <th>NAMA PERAWATAN</th>
                    <th>KATEGORI PERAWATAN</th>
                    <th v-if="id_asuransi != 1">DT</th>
                    <th>TARIF/BIAYA</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in nrs"
                      v-bind:key="item.id + Math.random(1024)"
                    >
                      <td>{{ item.tindakan.kode }}</td>
                      <td>{{ item.tindakan.nama }}</td>
                      <td>{{ item.tindakan.kategori }}</td>
                      <td v-if="id_asuransi != 1">
                        {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                      </td>
                      <td>{{ item.tindakan.formatted_biaya }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                      <td>
                        <h4 class="my-2">Total Biaya Penanganan Petugas</h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2">{{ convertToRupiah(nrs_count) }}</h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div
                  class="d-flex flex-between mt-4 mb-3"
                  v-if="both && both.length"
                >
                  <h5 class="mb-2">Penanganan oleh Dokter dan Petugas</h5>
                </div>
                <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'both')" v-if="s_both && a_both" :loading="l_both" :data="r_both" /> -->
                <table class="responsive" v-if="both && both.length">
                  <thead>
                    <th>KODE</th>
                    <th>NAMA PERAWATAN</th>
                    <th>KATEGORI PERAWATAN</th>
                    <th v-if="id_asuransi != 1">DT</th>
                    <th>TARIF/BIAYA</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in both"
                      v-bind:key="item.id + Math.random(1024)"
                    >
                      <td>{{ item.tindakan.kode }}</td>
                      <td>{{ item.tindakan.nama }}</td>
                      <td>{{ item.tindakan.kategori }}</td>
                      <td v-if="id_asuransi != 1">
                        {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                      </td>
                      <td>{{ item.tindakan.formatted_biaya }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                      <td>
                        <h4 class="my-2">
                          Total Biaya Penanganan Dokter dan Petugas
                        </h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2">
                          {{ convertToRupiah(both_count) }}
                        </h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <hr />
              </div>
            </div>
          </div>
          <div id="tagihanRanap" class="mt-4 mb-2" v-if="ranapRingkasan">
            <h4 class="mb-0">Tagihan Rawat Inap</h4>

            <div class="row">
              <div class="col-md-12">
                <div
                  class="row my-3"
                  v-if="dataTagihanKamarRanap && dataTagihanKamarRanap.length"
                >
                  <div class="col-md-10">
                    <h5 class="mb-0">Tagihan Kamar Inap</h5>
                  </div>
                  <div class="col-md-2">
                    <!-- <button
                        type="button"
                        class="
                          btn
                          btn-sm
                          btn-outline-secondary
                          btn-with-icon-left
                          btn-block
                        "
                        @click="$bvModal.show('ModalFormKamarRanap')"
                      >
                        <i class="material-symbols-outlined">create</i> Edit Tagihan
                      </button> -->
                  </div>
                </div>
                <table
                  class="responsive"
                  v-if="dataTagihanKamarRanap && dataTagihanKamarRanap.length"
                >
                  <thead>
                    <th>TANGGAL</th>
                    <th>NAMA KAMAR</th>
                    <th>NO. KASUR</th>
                    <th>KELAS</th>
                    <th>TARIF/BIAYA</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in dataTagihanKamarRanap"
                      v-bind:key="item.id"
                    >
                      <td>{{ item.formatted_tgl }}</td>
                      <td>{{ `${item.kamar_ranap.nama}` }}</td>
                      <td>{{ item.kamar_ranap.formatted_no_kasur }}</td>
                      <td>{{ `${item.kamar_ranap.formatted_kelas}` }}</td>
                      <td>
                        {{ item.formatted_biaya }}
                        <!-- <router-link
                            class="btn btn-icon btn-primary btn-sm mr-2 ml-3"
                            :to="`/ranap/form-tagihan/${$route.params.id}/edit/${item.id}`"
                          >
                            <i class="material-symbols-outlined">create</i>
                          </router-link> -->
                        <!-- <button class="btn btn-icon btn-danger btn-sm">
                            <i class="material-symbols-outlined">delete</i>
                          </button> -->
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <!-- <td :colspan="id_asuransi != 1 ? 4 : 3"></td> -->
                      <td :colspan="3"></td>
                      <td>
                        <h4 class="my-2">Total Tagihan</h4>
                      </td>
                      <td>
                        <h4 class="my-2 text-right">
                          {{ convertToRupiah(totalTagihanTagihanKamarRanap) }}
                        </h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div
              class="row mt-4 mb-0"
              v-if="
                (ranapDoc && ranapDoc.length) ||
                  (ranapNrs && ranapNrs.length) ||
                  (ranapBoth && ranapBoth.length)
              "
            >
              <div class="col-md-10">
                <h5 class="mb-0">Tagihan Tindakan Rawat Inap</h5>
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="
                    btn
                    btn-outline-secondary
                    btn-sm
                    btn-with-icon-left
                    btn-block
                  "
                  v-if="
                    ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                  "
                  @click="$bvModal.show('ModalFormTindakan Ranap')"
                >
                  <i class="material-symbols-outlined">create</i> Edit Tagihan
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" style="position: relative">
                <div
                  class="d-flex flex-between mt-4 mb-3"
                  v-if="ranapDoc && ranapDoc.length"
                >
                  <h5 class="mb-2">Penanganan oleh Dokter</h5>
                </div>
                <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'ranapDoc')" v-if="s_ranapDoc && a_ranapDoc" :loading="l_ranapDoc" :data="r_ranapDoc" /> -->

                <table v-if="ranapDoc && ranapDoc.length" class="responsive">
                  <thead>
                    <th>KODE</th>
                    <th>NAMA PERAWATAN</th>
                    <th>KATEGORI PERAWATAN</th>
                    <th v-if="id_asuransi != 1">DT</th>
                    <th>TARIF/BIAYA</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in ranapDoc"
                      v-bind:key="item.id + Math.random(1024)"
                    >
                      <td>{{ item.tindakan.kode }}</td>
                      <td>{{ item.tindakan.nama }}</td>
                      <td>{{ item.tindakan.kategori }}</td>
                      <td v-if="id_asuransi != 1">
                        {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                      </td>
                      <td>{{ item.tindakan.formatted_biaya }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                      <td>
                        <h4 class="my-2">Total Biaya Penanganan Dokter</h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2">
                          {{ convertToRupiah(ranapDoc_count) }}
                        </h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div
                  class="d-flex flex-between mt-4 mb-3"
                  v-if="ranapNrs && ranapNrs.length"
                >
                  <h5 class="mb-2">Penanganan oleh Petugas</h5>
                </div>
                <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'ranapNrs')" v-if="s_ranapNrs && a_ranapNrs" :loading="l_ranapNrs" :data="r_ranapNrs" /> -->
                <table class="responsive" v-if="ranapNrs && ranapNrs.length">
                  <thead>
                    <th>KODE</th>
                    <th>NAMA PERAWATAN</th>
                    <th>KATEGORI PERAWATAN</th>
                    <th v-if="id_asuransi != 1">DT</th>
                    <th>TARIF/BIAYA</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in ranapNrs"
                      v-bind:key="item.id + Math.random(1024)"
                    >
                      <td>{{ item.tindakan.kode }}</td>
                      <td>{{ item.tindakan.nama }}</td>
                      <td>{{ item.tindakan.kategori }}</td>
                      <td v-if="id_asuransi != 1">
                        {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                      </td>
                      <td>{{ item.tindakan.formatted_biaya }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                      <td>
                        <h4 class="my-2">Total Biaya Penanganan Petugas</h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2">
                          {{ convertToRupiah(ranapNrs_count) }}
                        </h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div
                  class="d-flex flex-between mt-4 mb-3"
                  v-if="ranapBoth && ranapBoth.length"
                >
                  <h5 class="mb-2">Penanganan oleh Dokter dan Petugas</h5>
                </div>
                <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'ranapBoth')" v-if="s_ranapBoth && a_ranapBoth" :loading="l_ranapBoth" :data="r_ranapBoth" /> -->
                <table class="responsive" v-if="ranapBoth && ranapBoth.length">
                  <thead>
                    <th>KODE</th>
                    <th>NAMA PERAWATAN</th>
                    <th>KATEGORI PERAWATAN</th>
                    <th v-if="id_asuransi != 1">DT</th>
                    <th>TARIF/BIAYA</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in ranapBoth"
                      v-bind:key="item.id + Math.random(1024)"
                    >
                      <td>{{ item.tindakan.kode }}</td>
                      <td>{{ item.tindakan.nama }}</td>
                      <td>{{ item.tindakan.kategori }}</td>
                      <td v-if="id_asuransi != 1">
                        {{ item.tindakan.ditanggung == 1 ? "Ya" : "Tdk" }}
                      </td>
                      <td>{{ item.tindakan.formatted_biaya }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td :colspan="id_asuransi != 1 ? 3 : 2"></td>
                      <td>
                        <h4 class="my-2">
                          Total Biaya Penanganan Dokter dan Petugas
                        </h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2">
                          {{ convertToRupiah(ranapBoth_count) }}
                        </h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <hr />
              </div>
            </div>
          </div>
          <div id="tagihanObat" class="mt-4 mb-2" v-if="obatRingkasan">
            <div class="row">
              <div class="col-md-10">
                <h4 class="mb-0">Tagihan Obat / Alkes</h4>
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="
                    btn
                    btn-outline-secondary
                    btn-sm
                    btn-with-icon-left
                    btn-block
                  "
                  v-if="
                    ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                  "
                  @click="$bvModal.show('ModalFormObat')"
                >
                  <i class="material-symbols-outlined">create</i> Edit Tagihan
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12" style="position: relative">
                <div class="d-flex flex-between my-3" v-if="obat.length">
                  <h5 class="mb-2">Resep Obat / Alkes</h5>
                </div>
                <table class="responsive" v-if="obat.length">
                  <thead>
                    <th>KODE / NAMA BARANG / JENIS OBAT / GOLONGAN OBAT</th>
                    <!-- <th>LOKASI</th> -->
                    <th>HARGA/SATUAN</th>
                    <th>JUMLAH</th>
                    <th>EMBALASE</th>
                    <th>TUSLAH</th>
                    <th>DISKON</th>
                    <th>ATURAN PAKAI</th>
                    <th v-if="id_asuransi != 1">DT</th>
                    <th>SUB TOTAL</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in obat"
                      v-bind:key="item.id + Math.random(1024)"
                    >
                      <td>
                        {{ item.kode }} / {{ item.nama }} / {{ item.jenis }} /
                        {{ item.golongan_obat }}
                      </td>
                      <td>{{ item.formatted_harga }}</td>
                      <td>{{ item.jumlah }}</td>
                      <td>{{ item.formatted_embalase }}</td>
                      <td>{{ item.formatted_tuslah }}</td>
                      <td>
                        {{ item.diskon_type != "Percentage" ? "Rp  " : ""
                        }}{{ convertToMoney(item.diskon)
                        }}{{ item.diskon_type == "Percentage" ? "%" : "" }}
                      </td>
                      <td>{{ item.catatan_dokter }}</td>
                      <td v-if="id_asuransi != 1">
                        {{ item.obat.ditanggung == 1 ? "Ya" : "Tdk" }}
                      </td>
                      <td>{{ item.formatted_sub_total }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td :colspan="id_asuransi != 1 ? 2 : 1"></td>
                      <td colspan="6">
                        <h4 class="my-2">Total Biaya Obat / Alkes</h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2">
                          {{ convertToRupiah(obat_count) }}
                        </h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <hr />
              </div>
            </div>
          </div>
          <div id="tagihanOptik" class="mt-4 mb-2" v-if="optikRingkasan">
            <div class="row">
              <div class="col-md-10">
                <h4 class="mb-0">Tagihan Optik</h4>
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="
                    btn
                    btn-outline-secondary
                    btn-sm
                    btn-with-icon-left
                    btn-block
                  "
                  v-if="
                    ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                  "
                  @click="$bvModal.show('ModalFormOptik')"
                >
                  <i class="material-symbols-outlined">create</i> Edit Tagihan
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" style="position: relative">
                <div class="d-flex flex-between my-3" v-if="optik.length">
                  <h5 class="mb-2">Resep Optik</h5>
                </div>
                <table class="responsive" v-if="optik.length">
                  <thead>
                    <th>KODE</th>
                    <th>NAMA BARANG</th>
                    <th>JENIS OBAT</th>
                    <th>LOKASI</th>
                    <th>HARGA/SATUAN</th>
                    <th>JUMLAH</th>
                    <th>EMBALASE</th>
                    <th>TUSLAH</th>
                    <th v-if="id_asuransi != 1">DT</th>
                    <th>SUB TOTAL</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in optik"
                      v-bind:key="item.id + Math.random(1024)"
                    >
                      <td>{{ item.optik.kode }}</td>
                      <td>{{ item.optik.nama }}</td>
                      <td>{{ item.optik.jenis }}</td>
                      <td>{{ item.optik.lokasi }}</td>
                      <td>{{ item.formatted_harga }}</td>
                      <td>{{ item.jumlah }}</td>
                      <td>{{ item.formatted_embalase }}</td>
                      <td>{{ item.formatted_tuslah }}</td>
                      <td v-if="id_asuransi != 1">
                        {{ item.optik.ditanggung == 1 ? "Ya" : "Tdk" }}
                      </td>
                      <td>{{ item.formatted_sub_total }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td :colspan="id_asuransi != 1 ? 4 : 3"></td>
                      <td colspan="5">
                        <h4 class="my-2">Total Biaya Optik</h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2">
                          {{ convertToRupiah(optik_count) }}
                        </h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <hr />
              </div>
            </div>
          </div>
          <div id="tagihanRalanLab" class="mt-4 mb-2" v-if="ralanLabRingkasan">
            <div class="row mb-3">
              <div class="col-md-10">
                <h4 class="mb-0">Tagihan Lab Rawat Jalan</h4>
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="
                    btn
                    btn-outline-secondary
                    btn-sm
                    btn-with-icon-left
                    btn-block
                  "
                  v-if="
                    ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                  "
                  @click="$bvModal.show('ModalFormLab')"
                >
                  <i class="material-symbols-outlined">create</i> Edit Tagihan
                </button>
              </div>
            </div>
            <table class="responsive" v-if="ralanLab.length">
              <thead>
                <th>KODE</th>
                <th>NAMA PEMERIKSAAN LAB</th>
                <th v-if="id_asuransi != 1">DT</th>
                <th>TARIF/BIAYA</th>
              </thead>
              <tbody>
                <tr
                  v-for="item in ralanLab"
                  v-bind:key="item.id + Math.random(1024)"
                >
                  <td>{{ item.periksalab.kode }}</td>
                  <td>{{ item.periksalab.nama }}</td>
                  <td v-if="id_asuransi != 1">
                    {{ item.periksalab.ditanggung == 1 ? "Ya" : "Tdk" }}
                  </td>
                  <td>{{ item.formatted_biaya }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td :colspan="id_asuransi != 1 ? 2 : 1"></td>
                  <td>
                    <h4 class="my-2">Total Biaya Pemeriksaan Lab</h4>
                  </td>
                  <td colspan="1" class="text-right">
                    <h4 class="my-2">{{ convertToRupiah(ralanLabCount) }}</h4>
                  </td>
                </tr>
              </tfoot>
            </table>
            <hr />
          </div>
          <div id="tagihanRanapLab" class="mt-4 mb-2" v-if="ranapLabRingkasan">
            <div class="row mb-3">
              <div class="col-md-10">
                <h4 class="mb-0">Tagihan Lab Rawat Inap</h4>
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="
                    btn
                    btn-outline-secondary
                    btn-sm
                    btn-with-icon-left
                    btn-block
                  "
                  @click="$bvModal.show('ModalFormLabRanap')"
                  v-if="
                    ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                  "
                >
                  <i class="material-symbols-outlined">create</i> Edit Tagihan
                </button>
              </div>
            </div>
            <table class="responsive" v-if="ranapLab.length">
              <thead>
                <th>KODE</th>
                <th>NAMA PEMERIKSAAN LAB</th>
                <th v-if="id_asuransi != 1">DT</th>
                <th>TARIF/BIAYA</th>
              </thead>
              <tbody>
                <tr
                  v-for="item in ranapLab"
                  v-bind:key="item.id + Math.random(1024)"
                >
                  <td>{{ item.periksalab.kode }}</td>
                  <td>{{ item.periksalab.nama }}</td>
                  <td v-if="id_asuransi != 1">
                    {{ item.periksalab.ditanggung == 1 ? "Ya" : "Tdk" }}
                  </td>
                  <td>{{ item.formatted_biaya }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td :colspan="id_asuransi != 1 ? 2 : 1"></td>
                  <td>
                    <h4 class="my-2">Total Biaya Pemeriksaan Lab</h4>
                  </td>
                  <td colspan="1" class="text-right">
                    <h4 class="my-2">{{ convertToRupiah(ranapLabCount) }}</h4>
                  </td>
                </tr>
              </tfoot>
            </table>
            <hr />
          </div>
          <div id="tagihanOperasi" class="mt-4 mb-2" v-if="operasiRingkasan">
            <div class="row mb-3">
              <div class="col-md-10">
                <h4 class="mb-0">Tagihan Operasi</h4>
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="
                    btn
                    btn-outline-secondary
                    btn-sm
                    btn-with-icon-left
                    btn-block
                  "
                  v-if="
                    ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                  "
                  @click="$bvModal.show('ModalFormOperasi')"
                >
                  <i class="material-symbols-outlined">create</i> Edit Tagihan
                </button>
              </div>
            </div>
            <table class="responsive" v-if="operasi">
              <thead>
                <th>KOMPONEN BIAYA</th>
                <th>SUB TOTAL</th>
              </thead>
              <tbody>
                <tr>
                  <td>Biaya Paket Operasi</td>
                  <td>
                    {{ convertToRupiah(operasi.jenis_paket_operasi) }}
                  </td>
                </tr>
                <tr>
                  <td>Jasa Dokter Operator</td>
                  <td>
                    {{ convertToRupiah(operasi.jasa_dokter_operator) }}
                  </td>
                </tr>
                <tr>
                  <td>Jasa Dokter Anestesi</td>
                  <td>
                    {{ convertToRupiah(operasi.jasa_dokter_anestesi) }}
                  </td>
                </tr>
                <!-- <tr>
                      <td>Jasa Dokter Referal</td>
                      <td>
                        {{ convertToRupiah(operasi.jasa_dokter_referal) }}
                      </td>
                    </tr> -->
                <tr>
                  <td>Jasa Perawat Anestesi</td>
                  <td>
                    {{ convertToRupiah(operasi.jasa_perawat_anestesi) }}
                  </td>
                </tr>
                <tr>
                  <td>Jasa Instrumentator</td>
                  <td>
                    {{ convertToRupiah(operasi.jasa_instrumentator) }}
                  </td>
                </tr>
                <tr>
                  <td>Jasa Perawat Sirkuler</td>
                  <td>
                    {{ convertToRupiah(operasi.jasa_perawat_sirkuler) }}
                  </td>
                </tr>
                <tr>
                  <td>Sewa Kamar Operasi</td>
                  <td>{{ convertToRupiah(operasi.sewa_kamar_operasi) }}</td>
                </tr>
                <tr>
                  <td>Pemberian Obat Dan Alat Kesehatan</td>
                  <td>
                    {{
                      convertToRupiah(operasi.pemberian_obat_dan_alat_kesehatan)
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Biaya Lain-lain</td>
                  <td>{{ convertToRupiah(operasi.biaya_lain_lain) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <h4 class="my-2">Total Biaya Operasi</h4>
                  </td>
                  <td colspan="1" class="text-right">
                    <h4 class="my-2">
                      {{ convertToRupiah(operasi.total_tagihan) }}
                    </h4>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <!-- <div class="row my-3">
            <div class="col-md-4 offset-md-2">
              <h4 class="mb-0 text-uppercase">Total Pembayaran</h4>
            </div>
            <div class="col-md-6">
              <h4 class="mb-0 text-right text-secondary">
                {{
                  ringkasan
                    ? convertToRupiah(ringkasan.all_tagihan_count.total_bayar)
                    : "Rp 0"
                }}
              </h4>
            </div>
          </div> -->

          <div class="py-1"></div>

          <div class="card px-4 py-3 mb-2 mt-3" v-if="ringkasan">
            <div class="row">
              <div class="col-md-12">
                <div class="row mb-3">
                  <div class="col-md-6">
                    <h4 class="mb-0 text-muted">Total Pembayaran</h4>
                  </div>
                  <div class="col-md-6">
                    <h4 class="mb-0 text-right">
                      {{
                        ringkasan
                          ? convertToRupiah(
                              ringkasan.all_tagihan_count.total_bayar
                            )
                          : "Rp 0"
                      }}
                    </h4>
                  </div>
                </div>
                <div
                  class="row mb-3"
                  v-if="ringkasan.all_tagihan_count.ditanggung"
                >
                  <div class="col-md-6">
                    <h4 class="mb-0 text-muted">Ditanggung</h4>
                  </div>
                  <div class="col-md-6">
                    <h4 class="text-right">
                      {{
                        ringkasan
                          ? convertToRupiah(
                              ringkasan.all_tagihan_count.ditanggung
                            )
                          : "Rp 0"
                      }}
                    </h4>
                    <h5 class="text-secondary">
                      Ditanggung oleh {{ asuransi[id_asuransi] }}
                      {{ asuransiLain ? ": " + asuransiLain.data.nama : "" }}
                    </h5>
                    <h5
                      class="text-muted text-right"
                      v-if="
                        ralan &&
                          ralan.data &&
                          ralan.data.pasien &&
                          ralan.data.pasien.no_peserta
                      "
                    >
                      Nomor Peserta : {{ ralan.data.pasien.no_peserta }}
                    </h5>
                    <!-- <div class="card p-2 my-3" style="background:#7f8f9">
                                <p class="mb-1">Ditanggung oleh {{asuransi[id_asuransi]}}</p>
                                <h5 class="mb-0">Ditanggung oleh {{asuransi[id_asuransi]}}</h5>
                            </div> -->
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-md-6">
                    <h4 class="mb-0 text-muted">Yang harus dibayar</h4>
                  </div>
                  <div class="col-md-6">
                    <h4 class="mb-0 text-info text-right">
                      {{
                        ringkasan
                          ? convertToRupiah(
                              ringkasan.all_tagihan_count.total_bayar -
                                ringkasan.all_tagihan_count.ditanggung
                            )
                          : "Rp 0"
                      }}
                    </h4>
                  </div>
                </div>
                <hr />
                <h4
                  class="text-muted"
                  v-if="
                    ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                  "
                >
                  Diskon
                </h4>
                <div
                  class="row mb-3 d-flex top"
                  v-if="
                    ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'BELUM DIBAYAR'
                  "
                ></div>
                <div class="row mb-3" v-else>
                  <div class="col-md-6">
                    <h4 class="mb-0 text-muted">Diskon</h4>
                  </div>
                  <div class="col-md-6">
                    <h4 class="mb-0 text-secondary text-right">
                      {{
                        ringkasan
                          ? convertToRupiah(ringkasan.all_tagihan_count.diskon)
                          : "Rp 0"
                      }}
                    </h4>
                  </div>
                </div>
                <hr />
                <div class="row mb-3">
                  <div class="col-md-6">
                    <h4 class="mb-0 text-muted">Telah dibayar</h4>
                  </div>
                  <div class="col-md-6">
                    <h4 class="text-primary text-right">
                      {{
                        ringkasan
                          ? convertToRupiah(ringkasan.all_tagihan_count.dibayar)
                          : "Rp 0"
                      }}
                    </h4>
                    <a
                      class="
                        btn btn-sm btn-outline-secondary btn-with-icon-right
                      "
                      @click="tab = 'riwayat'"
                    >
                      Lihat Riwayat Pembayaran
                      <i class="material-symbols-outlined">chevron_right</i>
                    </a>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-md-6">
                    <h4 class="mb-0 text-muted">Sisa bayar</h4>
                  </div>
                  <div class="col-md-6 text-right">
                    <h4 class="mb-0 text-danger">
                      {{
                        ringkasan
                          ? convertToRupiah(
                              ringkasan.all_tagihan_count.sisa_tagihan
                            )
                          : "Rp 0"
                      }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row"
              v-if="
                ringkasan &&
                  !(
                    (ringkasan &&
                      ringkasan.all_tagihan_count &&
                      ringkasan.all_tagihan_count.status == 'LUNAS') ||
                    ringkasan.all_tagihan_count.sisa_tagihan == 0
                  )
              "
            >
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  {{ lunas ? "LUNASI PEMBAYARAN" : "BAYAR" }}
                </button>
                <!-- <router-link class="btn btn-outline-danger btn-no-outline float-right text-uppercase" to="/kasir">Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => reset()"
                  >Batalkan</a
                >
              </div>
            </div>
          </div>

          <b-row v-if="riwayat && riwayat.length">
            <b-col md="12">
              <h3 class="mt-4 mb-3">Riwayat Pembayaran</h3>
              <table class="responsive my-4">
                <thead>
                  <tr>
                    <td colspan="3">
                      <h5 class="my-2 text-right">Yang harus dibayar</h5>
                    </td>
                    <td colspan="1" class="text-right">
                      <h5 class="my-2">
                        {{
                          ringkasan
                            ? convertToRupiah(
                                ringkasan.all_tagihan_count.total_bayar -
                                  ringkasan.all_tagihan_count.ditanggung
                              )
                            : "Rp 0"
                        }}
                      </h5>
                    </td>
                  </tr>
                  <tr v-if="ringkasan && ringkasan.all_tagihan_count.diskon">
                    <td colspan="3">
                      <h5 class="my-2 text-right">Diskon</h5>
                    </td>
                    <td colspan="1" class="text-right">
                      <h5 class="my-2">
                        {{
                          ringkasan
                            ? convertToRupiah(
                                ringkasan.all_tagihan_count.diskon
                              )
                            : "Rp 0"
                        }}
                      </h5>
                    </td>
                  </tr>
                </thead>
                <thead v-if="riwayat && riwayat.length">
                  <th>TANGGAL</th>
                  <th>JAM</th>
                  <th>CARA BAYAR</th>
                  <th>JUMLAH PEMBAYARAN</th>
                </thead>
                <tbody v-if="riwayat && riwayat.length">
                  <tr
                    v-for="item in riwayat"
                    v-bind:key="item.id + Math.random(1024)"
                  >
                    <td>{{ item.formatted_tanggal }}</td>
                    <td>{{ item.formatted_jam }}</td>
                    <td>
                      {{ item.cara_bayar
                      }}{{ item.no_kartu ? " - " + item.no_kartu : "" }}
                    </td>
                    <td>{{ item.formatted_jumlah }}</td>
                  </tr>
                </tbody>
                <tfoot v-if="riwayat && riwayat.length">
                  <tr>
                    <td colspan="2"></td>
                    <td>
                      <h4 class="my-2">SISA PEMBAYARAN</h4>
                    </td>
                    <td colspan="1" class="text-right">
                      <h4 class="mt-2 mb-2">
                        {{
                          ringkasan
                            ? convertToRupiah(
                                ringkasan.all_tagihan_count.sisa_tagihan
                              )
                            : "Rp 0"
                        }}
                      </h4>
                      <a
                        class="btn btn-sm btn-secondary btn-with-icon-right"
                        @click="tab = 'rincian'"
                      >
                        {{
                          ringkasan &&
                          ringkasan.all_tagihan_count &&
                          ringkasan.all_tagihan_count.status == "LUNAS"
                            ? "LIHAT RINCIAN"
                            : "LUNASI PEMBAYARAN"
                        }}
                        <i class="material-symbols-outlined">chevron_right</i>
                      </a>
                    </td>
                  </tr>
                </tfoot>
                <tfoot v-else>
                  <tr>
                    <td colspan="3">
                      <p class="text-right">
                        Belum ada Riwayat Pembayaran di sini
                      </p>
                    </td>
                    <td colspan="1" class="text-right">
                      <a
                        class="btn btn-sm btn-secondary btn-with-icon-right"
                        @click="tab = 'rincian'"
                      >
                        LAKUKAN PEMBAYARAN
                        <i class="material-symbols-outlined">chevron_right</i>
                      </a>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </b-col>
          </b-row>
          <!--/form-->
        </div>
        <!-- Nota Pembayaran -->
      </div>
    </div>
    <ModalFormOptik
      :no_rawat="no_rawat"
      :id_ralan="id_ralan"
      v-if="no_rawat && id_ralan"
      @onSave="() => onSaveEditTagihan()"
    />
    <ModalFormLab
      :no_rawat="no_rawat"
      :id_ralan="id_ralan"
      v-if="no_rawat && id_ralan"
      @onSave="() => onSaveEditTagihan()"
    />
    <ModalFormLabRanap
      :no_rawat="no_rawat"
      :id_ralan="id_ralan"
      v-if="no_rawat && id_ralan"
      @onSave="() => onSaveEditTagihan()"
    />
    <ModalFormOperasi
      :no_rawat="no_rawat"
      :id_ralan="id_ralan"
      @onSave="() => onSaveEditTagihan()"
      :id_operasi="operasi.id_operasi"
      v-if="operasi && no_rawat && id_ralan"
    />
    <ModalFormTindakan
      :no_rawat="no_rawat"
      :id_ralan="id_ralan"
      v-if="no_rawat && id_ralan"
      @onSave="() => onSaveEditTagihan()"
    />
    <ModalFormTindakanRanap
      :no_rawat="no_rawat"
      :id_ralan="id_ralan"
      v-if="no_rawat && id_ralan"
      @onSave="() => onSaveEditTagihan()"
    />
    <ModalFormKamarRanap
      :no_rawat="no_rawat"
      :id_ralan="id_ralan"
      v-if="no_rawat && id_ralan"
      @onSave="() => onSaveEditTagihan()"
    />
    <ModalFormObat
      :no_rawat="no_rawat"
      :id_ralan="id_ralan"
      v-if="no_rawat && id_ralan"
      @onSave="() => onSaveEditTagihan()"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
// import SearchResult from '@/components/SearchResult.vue'
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
// import DetailLeft from '@/components/DetailLeft.vue'
// import DetailRight from '@/components/DetailRight.vue'
import Loading from "@/components/Loading.vue";
import ModalFormTindakan from "@/components/modal/FormTindakan.vue";
import ModalFormTindakanRanap from "@/components/modal/FormTindakanRanap.vue";
import ModalFormObat from "@/components/modal/FormObat.vue";
import ModalFormOptik from "@/components/modal/FormOptik.vue";
import ModalFormLab from "@/components/modal/FormLab.vue";
import ModalFormLabRanap from "@/components/modal/FormLabRanap.vue";
import ModalFormOperasi from "@/components/modal/FormOperasi.vue";
import ModalFormKamarRanap from "@/components/modal/FormKamarRanap.vue";
import FormData from "form-data";
import {
  setBayarIntro,
  convertToRupiah,
  convertToMoney,
  resetForms,
} from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import { data, diskonForm, bayarForm } from "@/data/KasirForm.js";

export default {
  name: "KasirForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    DetailTop,
    Alert,
    FormRow,
    Loading,
    ModalFormOptik,
    ModalFormLab,
    ModalFormOperasi,
    ModalFormTindakan,
    ModalFormTindakanRanap,
    ModalFormObat,
    ModalFormKamarRanap,
    ModalFormLabRanap,
  },
  data: () => {
    return {
      no_rawat: "",
      fromUrl: "",
      plainUrl: "",
      id_asuransi: null,
      id_ralan: "",
      ralan: null,
      lunas: false,
      visible: false,
      tab: "rincian",
      data: data,
      convertToRupiah: convertToRupiah,
      convertToMoney: convertToMoney,
      history: [],
      asuransi: { 1: "Umum", 2: "BPJS", 3: "Asuransi" },
      asuransiLain: null,
      diskonForm: diskonForm,
      bayarForm: bayarForm,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      saveSuccess: false,
      saveFailed: false,
      formSet: {
        id_tagihan_ringkasan: "",
        id_bank: "",
        jumlah: "",
        cara_bayar: "Tunai",
        no_kartu: "",
        lunas: [],
      },
      formSetDiskon: {
        diskon_type: "Rp",
        diskon: "",
      },
      n: 0,
      doc: [],
      nrs: [],
      both: [],
      obat: [],
      optik: [],
      doc_count: 0,
      nrs_count: 0,
      both_count: 0,
      obat_count: 0,
      optik_count: 0,
      isError: false,
      ringkasan: null,
      riwayat: null,
      // data dari tagihan ranap
      dataTagihanKamarRanap: [],
      totalTagihanTagihanKamarRanap: 0,
      ranapDoc: [],
      ranapNrs: [],
      ranapBoth: [],
      ranapDoc_count: 0,
      ranapNrs_count: 0,
      ranapBoth_count: 0,
      ranapRingkasan: null,
      obatRingkasan: null,
      optikRingkasan: null,
      operasiRingkasan: null,
      operasi: null,
      id_biaya: null,
      ralanLab: [],
      ralanLabCount: 0,
      ralanLabRingkasan: null,
      ranapLab: [],
      ranapLabCount: 0,
      ranapLabRingkasan: null,
      // data dari tagihan ranap
    };
  },
  methods: {
    goBack(url) {
      //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      //console.log(backBtn);
      //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        //console.log(backBtn);
        this.$router.push({ path: backBtn + queryString });
      } else {
        //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      let self = this;
      self.errors = [];
      let formData = new FormData();
      let valid = this.validateForm();
      formData.append("no_rawat", this.no_rawat);
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          if (key != "lunas") {
            formData.append(key, self.formSet[key]);
          }
        });
        try {
          let result = await this.$store.state.HTTP.post(
            "menu/kasir/tagihan_pembayaran",
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.saveSuccess = true;
          } else {
            this.saveFailed = true;
          }
          this.checkSuccess();
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleFormDiskon: async function() {
      ////console.log(this.formSetDiskon.no_rm);
      this.errors = [];
      let formData = new FormData();
      formData.append("no_rawat", this.no_rawat);
      var self = this;
      let valid = this.validateFormDiskon();
      //console.log("store diskon");
      if (valid) {
        Object.keys(this.formSetDiskon).forEach(function(key) {
          formData.append(key, self.formSetDiskon[key]);
        });
        try {
          let result = await this.$store.state.HTTP.post(
            "menu/kasir/store-diskon",
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.init();
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        ////console.log("tidak valid");
      }
      //console.log("store diskon");
    },
    fetchBanks: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "bank?per_page=9999999999"
        );
        //////console.log(result);
        if (result.status == "200") {
          //////console.log(result.data);
          let items = result.data.data;
          //////console.log(items);
          this.bayarForm[3].columns[0].options = items.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //////console.log(e);
      }
    },
    checkSuccess() {
      var that = this;
      if (!this.saveFailed) {
        this.saveSuccess = true;
        that.reinit();
      } else {
        this.saveSuccess = false;
      }
      setTimeout(function() {
        that.saveSuccess = false;
        that.saveFailed = false;
      }, 3000);
    },
    reset(url, stay) {
      // if (this.validated) {
      resetForms(
        this.formSet,
        [this.diskonForm, this.bayarForm],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (!stay) {
          if (this.fromUrl && fromTab) {
            let queryString = "?tab=" + fromTab;

            ////console.log(backBtn)
            this.$router.push({ path: backBtn + queryString });
          } else {
            ////console.log(window.history);
            if (backBtn) {
              this.$router.push({ path: backBtn });
            } else {
              this.$router.go(-1);
            }
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    handleChangeDiskon(e) {
      this.formSetDiskon[e.target.name] = e.target.value;
      if (e.target.name == "diskon_type") {
        if (e.target.value == "Rp") {
          this.diskonForm[0].columns[1].value = "";
          this.diskonForm[0].columns[1].type = "money";
          this.diskonForm[0].columns[1].max = this.ringkasan.all_tagihan_count.sisa_tagihan;
        } else {
          this.diskonForm[0].columns[1].value = "";
          this.diskonForm[0].columns[1].type = "percentage";
          this.diskonForm[0].columns[1].max = 100;
        }
      }
      if (e.target.name == "diskon_type") {
        this.diskonForm[0].columns[0].value = this.formSetDiskon[e.target.name];
        //console.log(this.formSetDiskon);
      }
    },
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
      if (e.target.name == "cara_bayar") {
        if (e.target.value == "Tunai" || e.target.value == "") {
          this.bayarForm[3].columns[0].value = "";
          this.bayarForm[3].columns[0].type = "hidden";
          this.bayarForm[3].columns[0].optional = true;
          this.bayarForm[4].columns[0].type = "hidden";
          this.bayarForm[4].columns[0].optional = true;
          this.formSet["no_kartu"] = "";
          this.formSet["id_bank"] = "";
        } else {
          this.bayarForm[3].columns[0].type = "select";
          this.bayarForm[3].columns[0].optional = false;
          this.bayarForm[4].columns[0].type = "text";
          this.bayarForm[4].columns[0].optional = false;
        }
        this.bayarForm[0].columns[0].value = this.formSet["jumlah"];
        this.bayarForm[1].columns[0].value = this.formSet["lunas"];
        this.bayarForm[2].columns[0].value = this.formSet["cara_bayar"];
      }
      if (
        e.target.name == "jumlah" &&
        parseInt(e.target.value) <
          parseInt(this.ringkasan.all_tagihan_count.sisa_tagihan) &&
        this.lunas
      ) {
        this.formSet["lunas"] = [];
        this.bayarForm[1].columns[0].value = this.formSet["lunas"];
        this.bayarForm[0].columns[0].value = this.formSet["jumlah"];
        this.bayarForm[2].columns[0].value = this.formSet["cara_bayar"];
        this.lunas = false;
      }
      if (e.target.name == "lunas") {
        //console.log(e.target.value);
        // this.lunas=false;
        if (e.target.value && e.target.value.length) {
          this.lunas = true;
          this.bayarForm[0].columns[0].value = this.ringkasan.all_tagihan_count.sisa_tagihan;
          this.formSet[
            "jumlah"
          ] = this.ringkasan.all_tagihan_count.sisa_tagihan;
          // this.bayarForm[0].columns[0].value=revertToNumber(this.ringkasan.all_tagihan_count.sisa_tagihan);
        } else {
          this.formSet[e.target.name] = [];
          this.bayarForm[1].columns[0].value = this.formSet["lunas"];
          this.lunas = false;
          this.bayarForm[0].columns[0].value = 0;
          this.formSet["jumlah"] = 0;
        }
      }
    },
    updateForm() {
      this.bayarForm[0].columns[0].value = this.formSet["jumlah"];
      this.bayarForm[1].columns[0].value = this.formSet["lunas"];
      this.bayarForm[2].columns[0].value = this.formSet["cara_bayar"];
      this.bayarForm[3].columns[0].value = this.formSet["no_kartu"];
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      this.bayarForm = this.bayarForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            if (
              column.name == "jumlah" &&
              parseInt(self.formSet[column.name]) >
                parseInt(self.ringkasan.all_tagihan_count.sisa_tagihan)
            ) {
              valid = false;
              column.error =
                "Jumlah pembayaran lebih besar dari pada sisa tagihan";
            } else {
              column.error = "";
            }
          }
          if (self.formSet[column.name]) {
            column.value = self.formSet[column.name];
          }
          return column;
        });
        return row;
      });
      return valid;
    },
    validateFormDiskon: function() {
      let valid = true;
      let self = this;
      //console.log("============validateFormDiskon");
      //console.log(self.formSetDiskon);
      //console.log("============validateFormDiskon");
      //console.log(this.diskonForm);
      // return;
      this.diskonForm = this.diskonForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSetDiskon[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              column.max &&
              parseFloat(self.formSetDiskon[column.name]) >
                parseFloat(column.max)
            ) {
              valid = false;
              column.error = "Nilai tidak boleh lebih dari " + column.max;
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSetDiskon[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai tidak boleh negatif";
            } else {
              column.error = "";
            }
          }
          if (self.formSetDiskon[column.name]) {
            column.value = self.formSetDiskon[column.name];
          }
          return column;
        });
        return row;
      });
      return valid;
    },
    routeRingkasanByType: async function(allTagihan, reinit) {
      let that = this;
      //console.log("all tagihan");
      //console.log(allTagihan);
      //console.log("all tagihan");

      allTagihan.forEach(async (item) => {
        switch (item.nama) {
          case "rawat_jalan":
            break;
          case "rawat_jalan_periksa_lab":
            await that.fetchRalanLabRingkasan(item.id, reinit);
            break;
          case "rawat_jalan_obat":
            await that.fetchObatRingkasan(item.id, reinit);
            break;
          case "rawat_jalan_optik":
            await that.fetchOptikRingkasan(item.id, reinit);
            break;
          case "rawat_inap":
            await that.fetchRanapRingkasan(item.id, reinit);
            break;
          case "rawat_inap_periksa_lab":
            await that.fetchRanapLabRingkasan(item.id, reinit);
            break;
          case "operasi":
            await that.fetchOperasiRingkasan(
              item.id,
              item.id_operasi_biaya,
              reinit
            );
            break;
        }
      });
    },
    // Khusus untuk tagihan obat
    fetchObatRingkasan: async function(id, reinit) {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${id}`
        );
        //console.log("fetchObatRingkasan");
        //console.log(result);
        //console.log("fetchObatRingkasan");

        if (result.status == 200) {
          this.id_ralan = result.data.id_ralan;
          //this.id_asuransi = result.data.id_asuransi;
          this.obatRingkasan = result.data;
          if (!this.ralan) {
            this.ralan = await this.$store.state.HTTP.get(
              `ralan/${this.id_ralan}`
            );
            if (this.ralan?.data?.pasien?.asuransi_lain) {
              this.asuransiLain = await this.$store.state.HTTP.get(
                `asuransi_lain/${this.ralan.data.pasien.asuransi_lain}`
              );
              if (this.asuransiLain && this.asuransiLain.status == "200") {
                this.ralan.data.pasien.asuransi.nama += `: ${this.asuransiLain?.data?.nama}`;
                //console.log("this ralan");
                //console.log(this.ralan);
                //console.log("this ralan");
              }
            }
            //console.log(this.ralan);
            if (!this.detailTop) {
              this.detailTop = setBayarIntro(this.ralan.data);
            }
          }

          let resultObat = await this.$store.state.HTTP.get(
            `ralan/resep/obat?no_rawat=${this.ralan.data.no_rawat}`
          );
          if (resultObat.status == 200) {
            //console.log(resultObat);
            let that = this;
            this.obat = resultObat.data.data.filter((item) => {
              return item.status != "DIBATALKAN";
            });

            this.obat_count = 0;
            this.obat.forEach((item) => {
              //console.log(item);
              item.kode = item.obat.kode;
              item.nama = item.obat.nama;
              item.jenis = item.obat.jenis;
              item.lokasi = item.obat.lokasi;
              item.golongan_obat = item.obat.golongan_obat;
              item.diskon_type = item.diskon_type || "Rp";
              that.obat_count += item.sub_total;
            });
            //console.log(reinit);
            // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
            if (reinit && result.data.status == "LUNAS") {
              // //console.log(
              //   "Kirim data ke SIAKUN saat reinitialization jika status==LUNAS"
              // );
              //console.log(this.$store.state.HTTP_SIAKUN);
              await this.$store.state.HTTP_SIAKUN.post(
                "faktur-penjualan/tambah-simrs",
                {
                  kode_pelanggan: this.ralan.data.no_rm,
                  tanggal: new Date().toISOString().split("T")[0],
                  deskripsi: `Pembayaran Obat/Alkes ${this.ralan.data.no_rawat} - ${this.ralan.data.jen_periksa} ${this.ralan.data.pasien.nama}`,
                  isLunas: 1,
                  isPengirimanBarang: 0,
                  items: this.obat.map((item) => {
                    return {
                      kodeProduk: item.obat.kode,
                      deskripsi: item.obat.nama,
                      jumlahProduk: item.jumlah,
                      pajak_id: 0,
                      diskon: 0,
                      hargaSatuan: item.harga,
                      subtotal: item.sub_total,
                    };
                  }),
                }
              );
              ////console.log(resultSiakun);
            }
            // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
          }
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    // Khusus untuk tagihan obat
    // Khusus tagihan optik
    fetchOptikRingkasan: async function(id, reinit) {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${id}`
        );
        //console.log(result);
        if (result.status == 200) {
          this.id_ralan = result.data.id_ralan;
          //this.id_asuransi = result.data.id_asuransi;
          this.optikRingkasan = result.data;
          if (!this.ralan) {
            this.ralan = await this.$store.state.HTTP.get(
              `ralan/${this.id_ralan}`
            );
            if (this.ralan?.data?.pasien?.asuransi_lain) {
              this.asuransiLain = await this.$store.state.HTTP.get(
                `asuransi_lain/${this.ralan.data.pasien.asuransi_lain}`
              );
              if (this.asuransiLain && this.asuransiLain.status == "200") {
                this.ralan.data.pasien.asuransi.nama += `: ${this.asuransiLain?.data?.nama}`;
                //console.log("this ralan");
                //console.log(this.ralan);
                //console.log("this ralan");
              }
            }
            //console.log(this.ralan);
            this.detailTop = setBayarIntro(this.ralan.data);
          }

          let resultOptik = await this.$store.state.HTTP.get(
            `ralan/barang/optik?no_rawat=${this.ralan.data.no_rawat}`
          );
          if (resultOptik.status == 200) {
            //console.log(resultOptik);
            let that = this;
            this.optik = resultOptik.data.data.filter((item) => {
              return item.status != "DIBATALKAN";
            });
            this.optik_count = 0;
            this.optik.forEach((item) => {
              //console.log(item);
              that.optik_count += item.sub_total;
            });
            // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
            if (reinit && result.data.status == "LUNAS") {
              // //console.log(
              //   "Kirim data ke SIAKUN saat reinitialization jika status==LUNAS"
              // );
              //console.log(this.$store.state.HTTP_SIAKUN);
              await this.$store.state.HTTP_SIAKUN.post(
                "faktur-penjualan/tambah-simrs",
                {
                  kode_pelanggan: this.ralan.data.no_rm,
                  tanggal: new Date().toISOString().split("T")[0],
                  deskripsi: `Pembayaran Optik ${this.ralan.data.no_rawat} - ${this.ralan.data.jen_periksa} ${this.ralan.data.pasien.nama}`,
                  isLunas: 1,
                  isPengirimanBarang: 0,
                  items: this.optik.map((item) => {
                    return {
                      kodeProduk: item.optik.kode,
                      deskripsi: item.optik.nama,
                      jumlahProduk: item.jumlah,
                      pajak_id: 0,
                      diskon: 0,
                      hargaSatuan: item.harga,
                      subtotal: item.sub_total,
                    };
                  }),
                }
              );
              ////console.log(resultSiakun);
            }
            // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
          }
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    // Khusus tagihan optik
    // Khusus tagihan lab ralan
    fetchRalanLabRingkasan: async function(id, reinit) {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${id}`
        );
        //console.log(result);
        if (result.status == 200) {
          this.id_ralan = result.data.id_ralan;
          //this.id_asuransi = result.data.id_asuransi;
          this.ralanLabRingkasan = result.data;
          if (!this.ralan) {
            this.ralan = await this.$store.state.HTTP.get(
              `ralan/${this.id_ralan}`
            );
            if (this.ralan?.data?.pasien?.asuransi_lain) {
              this.asuransiLain = await this.$store.state.HTTP.get(
                `asuransi_lain/${this.ralan.data.pasien.asuransi_lain}`
              );
              if (this.asuransiLain && this.asuransiLain.status == "200") {
                this.ralan.data.pasien.asuransi.nama += `: ${this.asuransiLain?.data?.nama}`;
                //console.log("this ralan");
                //console.log(this.ralan);
                //console.log("this ralan");
              }
            }
            //console.log(this.ralan);
            this.detailTop = setBayarIntro(this.ralan.data);
          }
          let resultLab = await this.$store.state.HTTP.get(
            `ralan/pemeriksaan/lab?no_rawat=${this.ralan.data.no_rawat}`
          );
          if (resultLab.status == 200) {
            //console.log("======================================= resultLab");
            //console.log(resultLab);
            //console.log("======================================= resultLab");

            this.ralanLab = resultLab.data.filter((item) => {
              return item.status != "DIBATALKAN";
            });
            this.ralanLabCount = 0;
            this.ralanLab.forEach((item) => {
              //console.log(item);
              this.ralanLabCount += item.biaya;
            });
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
          if (reinit && result.data.status == "LUNAS") {
            // //console.log(
            //   "Kirim data ke SIAKUN saat reinitialization jika status==LUNAS"
            // );
            //console.log(this.$store.state.HTTP_SIAKUN);
            await this.$store.state.HTTP_SIAKUN.post(
              "faktur-penjualan/tambah-simrs",
              {
                kode_pelanggan: this.ralan.data.no_rm,
                tanggal: new Date().toISOString().split("T")[0],
                deskripsi: `Pemeriksaan Lab ${this.ralan.data.no_rawat} - ${this.ralan.data.jen_periksa} ${this.ralan.data.pasien.nama}`,
                isLunas: 1,
                isPengirimanBarang: 0,
                items: [
                  {
                    kodeProduk: "Lab",
                    deskripsi: `Total Biaya Pemeriksaan Lab`,
                    jumlahProduk: 1,
                    pajak_id: 0,
                    diskon: 0,
                    hargaSatuan: result.data.dibayar,
                    subtotal: result.data.dibayar,
                  },
                ],
              }
            );
            ////console.log(resultSiakun);
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    // khusus tagihan lab ralan
    // Khusus tagihan lab ranap
    fetchRanapLabRingkasan: async function(id, reinit) {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${id}`
        );
        //console.log(result);
        if (result.status == 200) {
          this.id_ralan = result.data.id_ralan;
          //this.id_asuransi = result.data.id_asuransi;
          this.ranapLabRingkasan = result.data;
          if (!this.ralan) {
            this.ralan = await this.$store.state.HTTP.get(
              `ralan/${this.id_ralan}`
            );
            if (this.ralan?.data?.pasien?.asuransi_lain) {
              this.asuransiLain = await this.$store.state.HTTP.get(
                `asuransi_lain/${this.ralan.data.pasien.asuransi_lain}`
              );
              if (this.asuransiLain && this.asuransiLain.status == "200") {
                this.ralan.data.pasien.asuransi.nama += `: ${this.asuransiLain?.data?.nama}`;
                //console.log("this ralan");
                //console.log(this.ralan);
                //console.log("this ralan");
              }
            }
            //console.log(this.ralan);
            this.detailTop = setBayarIntro(this.ralan.data);
          }
          let resultLab = await this.$store.state.HTTP.get(
            `ranap/pemeriksaan/lab?no_rawat=${this.ralan.data.no_rawat}`
          );
          if (resultLab.status == 200) {
            //console.log(resultLab);
            // this.ranapLab = resultLab.data;
            this.ranapLab = resultLab.data.data.filter((item) => {
              return item.status != "DIBATALKAN";
            });
            this.ranapLabCount = 0;
            this.ranapLab.forEach((item) => {
              //console.log(item);
              this.ranapLabCount += item.biaya;
            });
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
          if (reinit && result.data.status == "LUNAS") {
            // //console.log(
            //   "Kirim data ke SIAKUN saat reinitialization jika status==LUNAS"
            // );
            //console.log(this.$store.state.HTTP_SIAKUN);
            await this.$store.state.HTTP_SIAKUN.post(
              "faktur-penjualan/tambah-simrs",
              {
                kode_pelanggan: this.ralan.data.no_rm,
                tanggal: new Date().toISOString().split("T")[0],
                deskripsi: `Pemeriksaan Lab ${this.ralan.data.no_rawat} - ${this.ralan.data.jen_periksa} ${this.ralan.data.pasien.nama}`,
                isLunas: 1,
                isPengirimanBarang: 0,
                items: [
                  {
                    kodeProduk: "Lab",
                    deskripsi: `Total Biaya Pemeriksaan Lab`,
                    jumlahProduk: 1,
                    pajak_id: 0,
                    diskon: 0,
                    hargaSatuan: result.data.dibayar,
                    subtotal: result.data.dibayar,
                  },
                ],
              }
            );
            ////console.log(resultSiakun);
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },

    // Khusus tagihan lab ranap
    // Khusus untuk tagihan operasi
    fetchOperasiRingkasan: async function(id, idOperasiBiaya, reinit) {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${id}`
        );
        //console.log("result operasi");
        //console.log(result);
        //console.log("result operasi");

        if (result.status == 200) {
          // this.id_ralan = result.data.id_ralan;
          // //this.id_asuransi = result.data.id_asuransi;
          this.operasiRingkasan = result.data;
          if (!this.ralan) {
            this.ralan = await this.$store.state.HTTP.get(
              `ralan/${this.id_ralan}`
            );
            if (this.ralan?.data?.pasien?.asuransi_lain) {
              this.asuransiLain = await this.$store.state.HTTP.get(
                `asuransi_lain/${this.ralan.data.pasien.asuransi_lain}`
              );
              if (this.asuransiLain && this.asuransiLain.status == "200") {
                this.ralan.data.pasien.asuransi.nama += `: ${this.asuransiLain?.data?.nama}`;
                //console.log("this ralan");
                //console.log(this.ralan);
                //console.log("this ralan");
              }
            }
            //console.log(this.ralan);
            this.detailTop = setBayarIntro(this.ralan.data);
          }
          this.id_biaya = idOperasiBiaya;
          //console.log(this.id_biaya);
          let resultOperasi = await this.$store.state.HTTP.get(
            `operasi_biaya/${this.id_biaya}`
          );
          if (resultOperasi.status == 200) {
            //console.log(resultOperasi);
            this.operasi = resultOperasi.data;
            //console.log(this.operasi);
            // this.operasi_count=0;
            // this.operasi.forEach((item)=>{
            //   //console.log(item);
            //   this.operasi_count+=item.biaya;
            // })
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
          if (reinit && result.data.status == "LUNAS") {
            // //console.log(
            //   "Kirim data ke SIAKUN saat reinitialization jika status==LUNAS"
            // );
            //console.log(this.$store.state.HTTP_SIAKUN);
            await this.$store.state.HTTP_SIAKUN.post(
              "faktur-penjualan/tambah-simrs",
              {
                kode_pelanggan: this.ralan.data.no_rm,
                tanggal: new Date().toISOString().split("T")[0],
                deskripsi: `Operasi ${this.ralan.data.no_rawat} - ${this.ralan.data.jen_periksa} ${this.ralan.data.pasien.nama}`,
                isLunas: 1,
                isPengirimanBarang: 0,
                items: [
                  {
                    kodeProduk: "Operasi",
                    deskripsi: `Total Biaya Operasi`,
                    jumlahProduk: 1,
                    pajak_id: 0,
                    diskon: 0,
                    hargaSatuan: result.data.dibayar,
                    subtotal: result.data.dibayar,
                  },
                ],
              }
            );
            ////console.log(resultSiakun);
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    // Khusus untuk tagihan operasi
    // Khusus untuk tagihan rawat inap
    fetchRanapRingkasan: async function(id, reinit) {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${id}`
        );
        //console.log(result);
        if (result.status == 200) {
          this.id_ralan = result.data.id_ralan;
          this.no_rawat = result.data.no_rawat;
          //this.id_asuransi = result.data.id_asuransi;
          this.ranapRingkasan = result.data;
          if (!this.ralan) {
            this.ralan = await this.$store.state.HTTP.get(
              `ralan/${this.id_ralan}`
            );
            if (this.ralan?.data?.pasien?.asuransi_lain) {
              this.asuransiLain = await this.$store.state.HTTP.get(
                `asuransi_lain/${this.ralan.data.pasien.asuransi_lain}`
              );
              if (this.asuransiLain && this.asuransiLain.status == "200") {
                this.ralan.data.pasien.asuransi.nama += `: ${this.asuransiLain?.data?.nama}`;
                //console.log("this ralan");
                //console.log(this.ralan);
                //console.log("this ralan");
              }
            }
            //console.log(this.ralan);
            this.detailTop = setBayarIntro(this.ralan.data);
          }
          let resultTindakan = await this.$store.state.HTTP.get(
            `ranap/tindakan/penanganan?no_rawat=${this.ralan.data.no_rawat}`
          );
          if (resultTindakan.status == 200) {
            //console.log(resultTindakan);
            let that = this;
            this.ranapDoc = resultTindakan.data.penanganan_dokter;
            this.ranapBoth = resultTindakan.data.penanganan_dokter_petugas;
            this.ranapNrs = resultTindakan.data.penanganan_petugas;
            // this.ranapDoc_count=this.ranapRingkasan.formatted_sub_total_dok;
            // this.ranapNrs_count=this.ranapRingkasan.formatted_sub_total_ptg;
            // this.ranapBoth_count=this.ranapRingkasan.formatted_sub_total_dp;
            that.ranapDoc_count = 0;
            that.ranapNrs_count = 0;
            that.ranapBoth_count = 0;
            this.ranapDoc.forEach((item) => {
              //console.log(item);
              that.ranapDoc_count += item.biaya;
            });
            this.ranapNrs.forEach((item) => {
              //console.log(item);
              that.ranapNrs_count += item.biaya;
            });
            this.ranapBoth.forEach((item) => {
              //console.log(item);
              that.ranapBoth_count += item.biaya;
            });
          }
          await this.fetchTagihanKamarRanap();
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
          if (reinit && result.data.status == "LUNAS") {
            // //console.log(
            //   "Kirim data ke SIAKUN saat reinitialization jika status==LUNAS"
            // );
            //console.log(this.$store.state.HTTP_SIAKUN);
            await this.$store.state.HTTP_SIAKUN.post(
              "faktur-penjualan/tambah-simrs",
              {
                kode_pelanggan: this.ralan.data.no_rm,
                tanggal: new Date().toISOString().split("T")[0],
                deskripsi: `Rawat Inap ${this.ralan.data.no_rawat} - ${this.ralan.data.jen_periksa} ${this.ralan.data.pasien.nama}`,
                isLunas: 1,
                isPengirimanBarang: 0,
                items: [
                  {
                    kodeProduk: "Ranap",
                    deskripsi: `Total Biaya Rawat Inap`,
                    jumlahProduk: 1,
                    pajak_id: 0,
                    diskon: 0,
                    hargaSatuan: result.data.dibayar,
                    subtotal: result.data.dibayar,
                  },
                ],
              }
            );
            ////console.log(resultSiakun);
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchTagihanKamarRanap: async function() {
      let res = await this.$store.state.HTTP.get(
        `ranap?no_rawat=${this.no_rawat}`
      );
      let self = this;
      //console.log(res);
      if (res && res.data.data.length) {
        try {
          let result = await this.$store.state.HTTP.get(
            `/ranap/tagihan/kamar?id_ranap=${res.data.data[0].id}`
          );
          //console.log(result);
          if (result.status == "200") {
            //console.log(result);
            this.totalTagihanTagihanKamarRanap = 0;
            this.dataTagihanKamarRanap = result.data.data.map((item) => {
              self.totalTagihanTagihanKamarRanap += item.biaya;
              return item;
            });
            //console.log(this.dataTagihanKamarRanap);
          } else {
            //console.log(result.status);
          }
        } catch (e) {
          //console.log(e);
          // this.errors.push(e);
          // this.saveFailed=true;
        }
      }
    },
    // Khusus untuk tagihan rawat inap
    fetchRingkasan: async function(reinit) {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${this.$route.params.id}`
        );
        //console.log("tagihan ringkasan");
        //console.log(result);
        //console.log("tagihan ringkasan");

        if (result.status == 200) {
          this.id_ralan = result.data.id_ralan;
          this.no_rawat = result.data.no_rawat;
          //this.id_asuransi = result.data.id_asuransi;
          this.ringkasan = result.data;
          this.diskonForm[0].columns[1].max = this.ringkasan.all_tagihan_count.sisa_tagihan;
          //console.log(this.ralan);
          if (!this.ralan) {
            this.ralan = await this.$store.state.HTTP.get(
              `ralan/${this.id_ralan}`
            );
            //console.log(this.ralan);
            //console.log("ya dapet");
            if (this.ralan?.data?.pasien?.asuransi_lain) {
              //console.log("masuk euy");
              this.asuransiLain = await this.$store.state.HTTP.get(
                `asuransi_lain/${this.ralan.data.pasien.asuransi_lain}`
              );
              if (this.asuransiLain && this.asuransiLain.status == "200") {
                this.ralan.data.pasien.asuransi.nama += `: ${this.asuransiLain?.data?.nama}`;
                //console.log("this ralan");
                //console.log(this.ralan);
                //console.log("this ralan");
              }
            }
            //console.log(this.ralan);
            this.detailTop = setBayarIntro(this.ralan.data);
          }

          if (result.data.all_tagihan && result.data.all_tagihan.length) {
            this.routeRingkasanByType(result.data.all_tagihan, reinit);
          }
          //console.log("result ralan");
          //console.log(this.ralan);
          this.id_asuransi = this.ralan.data.id_asuransi;
          //console.log("result ralan");

          if (!this.detailTop) {
            this.detailTop = setBayarIntro(this.ralan.data);
          }
          let resultTindakan = await this.$store.state.HTTP.get(
            `ralan/tindakan/penanganan?no_rawat=${this.ralan.data.no_rawat}`
          );
          if (resultTindakan.status == 200) {
            //console.log(resultTindakan);
            let that = this;
            this.doc = resultTindakan.data.penanganan_dokter;
            this.both = resultTindakan.data.penanganan_dokter_petugas;
            this.nrs = resultTindakan.data.penanganan_petugas;
            // this.doc_count=this.ringkasan.all_tagihan_count.formatted_sub_total_dok;
            // this.nrs_count=this.ringkasan.all_tagihan_count.formatted_sub_total_ptg;
            // this.both_count=this.ringkasan.all_tagihan_count.formatted_sub_total_dp;
            that.doc_count = 0;
            that.nrs_count = 0;
            that.both_count = 0;
            this.doc.forEach((item) => {
              //console.log(item);
              that.doc_count += item.biaya;
            });
            this.nrs.forEach((item) => {
              //console.log(item);
              that.nrs_count += item.biaya;
            });
            this.both.forEach((item) => {
              //console.log(item);
              that.both_count += item.biaya;
            });
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
          if (reinit && result.data.status == "LUNAS") {
            // //console.log(
            //   "Kirim data ke SIAKUN saat reinitialization jika status==LUNAS"
            // );
            //console.log(this.$store.state.HTTP_SIAKUN);
            await this.$store.state.HTTP_SIAKUN.post(
              "faktur-penjualan/tambah-simrs",
              {
                kode_pelanggan: this.ralan.data.no_rm,
                tanggal: new Date().toISOString().split("T")[0],
                deskripsi: `Rawat Jalan ${this.ralan.data.no_rawat} - ${this.ralan.data.jen_periksa} ${this.ralan.data.pasien.nama}`,
                isLunas: 1,
                isPengirimanBarang: 0,
                items: [
                  {
                    kodeProduk: "Ralan",
                    deskripsi: `Total Biaya Rawat Jalan`,
                    jumlahProduk: 1,
                    pajak_id: 0,
                    diskon: 0,
                    hargaSatuan: result.data.dibayar,
                    subtotal: result.data.dibayar,
                  },
                ],
              }
            );
            ////console.log(resultSiakun);
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchRiwayat: async function() {
      let formData = new FormData();
      formData.append("no_rawat", this.no_rawat);
      try {
        let result = await this.$store.state.HTTP.post(
          `menu/kasir/tagihan_pembayaran_by_no_rawat`,
          formData
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log("riwayat");
          //console.log(result);
          //console.log("riwayat");
          this.riwayat = result.data;
          this.riwayat = this.riwayat.map((item) => {
            if (item.id_bank && item.bank) {
              item.no_kartu += ` ( ${item.bank.kode} - ${item.bank.nama} )`;
            }
            return item;
          });
          //console.log(this.riwayat);
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    init: async function() {
      this.tab = this.$route.params.tab;
      this.formSet.id_tagihan_ringkasan = this.$route.params.id;
      await this.fetchRingkasan();
      //console.log(this.id_asuransi);
      await this.fetchRiwayat();
    },
    print: async function() {
      if (this.ringkasan && this.riwayat) window.print();
    },
    reinit: async function() {
      this.tab = this.$route.params.tab;
      this.formSet.id_tagihan_ringkasan = this.$route.params.id;
      await this.fetchRingkasan(true);
      await this.fetchRiwayat();
      this.reset("", true);
    },
    onSaveEditTagihan: async function() {
      //console.log("masuk berhasil edit tagihan");
      this.tab = this.$route.params.tab;
      this.formSet.id_tagihan_ringkasan = this.$route.params.id;
      await this.fetchRingkasan(true);
      await this.fetchRiwayat();
      // await this.fetchBanks();
      this.data.toReset = (url) => this.reset(url);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    await this.init();
    await this.fetchBanks();
    this.data.toReset = (url) => this.reset(url);
  },
};
</script>
